import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { API_URL } from "../../../constants";
import {
  GetServiceCaller,
  PostServiceCaller,
  PostFormServiceCaller
} from "../../../services/serviceCaller";
import EditorComponent from "../../../components/editor";
import Select from "react-select";
import CustomDatePicker from "../../../components/Custom-Datepicker";
import moment from "moment";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { Modal, Button, Form } from "react-bootstrap";
import FileUploader from "../../../components/FileUploader";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { Table } from "react-bootstrap";
import { FaSpinner } from "react-icons/fa";
import * as Yup from "yup";
import { useDispatch } from "react-redux";
import { updateNavbarHeading } from "../../../constants/layout/store/filterSlice";

const customStyle = {
  control: (provided, state) => ({
    ...provided,
    height: "80px",
    overflow: "scroll",
  }),
  multiValueRemove: (base, state) => ({
    ...base,
    color: "white", // Sets the color of the cancel icon
    ":hover": {
      backgroundColor: "red", // Adjust hover background color if needed
      color: "white", // Adjust hover color here
    },
  }),
};

export const experienceOptions = [
  { value: "0 - 1 Years", label: "0 - 1 Years" },
  { value: "0.6 - 2 Year", label: "0.6 - 2 Year" },
  { value: "2 - 4 Year", label: "2 - 4 Year" },
  { value: "4 - 6 Years", label: "4 - 6 Years" },
  { value: "6 - 8 Years", label: "6 - 8 Years" },
  { value: "7 - 9 Years", label: "7 - 9 Years" },
  { value: "8 - 10 Years", label: "8 - 10 Years" },
  { value: "10 - 12 Years", label: "10 - 12 Years" },
  { value: "12 - 14 years", label: "12 - 14 years" },
  { value: "13 - 16 Years", label: "13 - 16 Years" },
  { value: "15 - 18 Years", label: "15 - 18 Years" },
  { value: "18 - 20 Years", label: "18 - 20 Years" },
  { value: "20+ Years", label: "20+ Years" },
];

  const mapLegacyExperienceToRange = (value) => {
  if (!value || isNaN(value)) return value;
  const num = parseFloat(value);
  if (num <= 1) return "0 - 1 Years";
  if (num > 1 && num <= 2) return "0.6 - 2 Year";
  if (num > 2 && num <= 4) return "2 - 4 Year";
  if (num > 4 && num <= 6) return "4 - 6 Years";
  if (num > 6 && num <= 8) return "6 - 8 Years";
  if (num > 8 && num <= 10) return "8 - 10 Years";
  if (num > 10 && num <= 12) return "10 - 12 Years";
  if (num > 12 && num <= 14) return "12 - 14 years";
  if (num > 14 && num <= 16) return "13 - 16 Years";
  if (num > 16 && num <= 18) return "15 - 18 Years";
  if (num > 18 && num <= 20) return "18 - 20 Years";
  if (num > 20) return "20+ Years";
  return value;
};

const EditCustomerRequirement = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(updateNavbarHeading("Edit Customer Requirement"));
  }, []);
  const initialFormData = {
    JobCode: "",
    PositionName: "",
    Description: "",
    Technology: [],
    NumOpenings: "",
    OpeningType: "",
    RequirementHiringType: "",
    ClientID: "",
    LocationType: "",
    HiringType: "",
    Location: [],
    MinExp: "",
    RequirementType: "Customer",
    MaxExp: "",
    Client_Priority: "",
    EmployeeGroup_ID: "",
    BillingTypeID: "",
    RMGStatusID: "",
    client_Partner: "",
    Delivery_Partner: "",
    Project_Manager: "",
    Shift: "",
    RomID: "",
    JobStatus: "",
    Reason:"",
    IsInActive: "",
    Priority: "1",
    Client_poc: "",
    Role: "",
    RequirementDate: null,
    BillingStartDate: null,
    skill: [],
    ProjectType: "",
    AccountManager: "",
    Currency: "",
    CostFre: "",
    Tenure: "",
    TenureFrequency: "",
    Revenue: "",
    RegionID: "",
    JobStatsChangeDate:null,
    AgingDays:"",
    TrackerID: "",
    JobFamilyID: "",
    PersonalAreaID: "",
    PersonalSubAreaID: "",
    RequisitionSourceID: "",
    EmployeeGroup_ID: "",
  };

  const [skillSetOptions, setSkillSetOptions] = useState([]);
  const [subSkillOptions, setSubSkillOptions] = useState([]);
  const [subSkillOption1, setSubSkillOptions1] = useState([]);
  const [fileUrl, setFileUrl] = useState(null);
  const [loading, setLoading] = useState();
  const [errors, setErrors] = useState();
  const [jobTitleOption, setJobTitleOption] = useState([]);
  const [jobStatusOption, setJobStatusOption] = useState([]);
  const [currecyOption, setCurrecyOption] = useState([]);
  const [requirementTypeOptions, setRequirementTypeOptions] = useState([]);
  const [clientOption, setClientOption] = useState([]);
  const [locationOption, setLocationOption] = useState([]);
  const [trackOption, setTrackOption] = useState([]);
  const [jobFamilyOption, setJobFamilyOption] = useState([]);
  const [experienceOption, setExperienceOption] = useState([]);
  const [personalAreaOption, setPersonalAreaOption] = useState([]);
  const [personalSubAreaOption, setPersonalSubAreaOption] = useState([]);
  const [requisitionSourceOption, setRequisitionSourceOption] = useState([]);
  const [employeeGroupOption, setEmployeeGroupOption] = useState([]);
  const [billingTypeOption, setBillingTypeOption] = useState([]);
  const [rmgStatusOption, setRmgStatusOption] = useState([]);
  const [mergeLineData, setMergeLineData] = useState([]);
  const [splitLocation, setSplitLocation] = useState([]);
  const [mappLoc, setMappLoc] = useState([]);
  const [clientSelectRomPoc, setClientSelectRomPoc] = useState([]);
  const [clientRegionValue, setClientRegionValue] = useState([]);
  const [allowAgingCalculation, setAllowAgingCalculation] = useState(false);
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [initialBackendStatus, setInitialBackendStatus] = useState(null);
  const [clientSelectAccountManager, setClientSelectAccountManager] = useState(
    []
  );
  const [regionoption, setRegionoption] = useState([]);
  const [formData, setFormData] = useState(initialFormData);
  const validationSchema = Yup.object().shape({
    NumOpenings: Yup.number().required("NumOpenings is required"),
    Currency: Yup.string().required("Currency is required"),
    Tenure: Yup.string().required("Tenure is required"),
    Client_Priority: Yup.number()
      .typeError("Client Priority is required")
      .required("Client Priority is required"),
    Role: Yup.string().required("Role is required"),
    ClientID: Yup.number()
      .typeError("Client Name is required")
      .required("Client Name is required"),
    Rate: Yup.number().required("Rate is required"),
    
    RequirementDate: Yup.string().required("Date is required"),
    BillingStartDate: Yup.string().required("Billing Start Date is required"),
    CostFrequency: Yup.string().required("Cost Frequency is required"),
    TenureFrequency: Yup.string().required("Tenure Frequency is required"),
    LocationType: Yup.string().nullable(),
    Reason:Yup.string().nullable(),
    JobStatus: Yup.string(),
    MinExp: Yup.string()
      .typeError("Relv Exp is required")
      .required("Relv Exp is required"),

    MaxExp: Yup.string()
      .typeError("Total Exp is required")
      .required("Total Exp is required"),

    NumOpenings: Yup.number()
      .typeError("Openings # is required")
      .required("Openings # is required"),

    Location: Yup.array()
      .required("Location is required")
      .min(1, "Location is required"),
    HiringType: Yup.string().required("Engagement Type is required"),
    RequirementHiringType: Yup.string().required("Hiring Type is required"),
    Priority: Yup.string().required("RMG Priority is required"),
    Technology: Yup.array()
      .required("Sub Skill is required")
      .min(1, "At least one sub-skill must be selected"), // Ensure at least one item in array
    skill: Yup.array()
      .required(" Skill is required")
      .min(1, "At least one skill must be selected"),
    BillingTypeID: Yup.string().when("RequirementHiringType", {
      is: (val) => val !== "4",
      then: (schema) => schema.required("Billing Type is required"),
      otherwise: (schema) => schema.nullable()
    }),
  });
  const validateField = async (name, value) => {
    const internalOption = requirementTypeOptions.find(o => o.code === 'INT' || String(o.label).toLowerCase() === 'internal');
    const isLocked = internalOption && (String(formData?.RequirementType) === String(internalOption.value));
    const fieldsToSkip = ["Tenure", "Rate", "TenureFrequency", "CostFrequency", "Client_Priority", "Currency", "Revenue", "BillingStartDate"];
    
    if (isLocked && fieldsToSkip.includes(name)) {
      setErrors((prevErrors) => ({ ...prevErrors, [name]: "" }));
      return true;
    }

    try {
      await validationSchema.validateAt(name, { ...formData, [name]: value });
      setErrors((prevErrors) => ({ ...prevErrors, [name]: "" }));
      return true;
    } catch (err) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        [name]: err.message,
      }));
      return false;
    }
  };

const validateForm = async () => {
  try {
    await validationSchema.validate(formData, { abortEarly: false }); // Validate entire form
    setErrors({}); // Clear all errors
    return true;
  } catch (err) {
    const newErrors = {};

    // 1. Map validation errors safely, ignoring internal schema mismatch paths
    if (err.inner) {
      err.inner.forEach((curr) => {
        // Only map if it's a real field validation message, not a schema crash
        if (curr.path && !curr.message.includes("schema does not contain the path")) {
          newErrors[curr.path] = curr.message;
        }
      });
    }

    // 2. Clear out client 354 read-only blockers
    const internalOption = requirementTypeOptions.find(o => o.code === 'INT' || String(o.label).toLowerCase() === 'internal');
    const clientReadOnlyFlag = internalOption && (String(formData?.RequirementType) === String(internalOption.value));
    if (clientReadOnlyFlag) {
      const fieldsToSkip = [
        "Tenure", 
        "Rate", 
        "TenureFrequency", 
        "CostFrequency", 
        "Client_Priority", 
        "Currency", 
        "Revenue",
        "BillingStartDate"
      ];
      
      fieldsToSkip.forEach(field => {
        delete newErrors[field];
      });
    }

    setErrors(newErrors); // Set cleaned form-level errors
    
    // 3. Return true if NO errors are left after skipping the read-only fields!
    return Object.keys(newErrors).length === 0;
  }
};

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData((prevState) => {
      const updated = { ...prevState, [name]: value };
      if (name === "RequirementType") {
        updated.Currency = "";
        updated.CostFrequency = "";
        updated.Rate = "";
        updated.Tenure = "";
        updated.TenureFrequency = null;
        updated.Revenue = "";
      }
      return updated;
    });
    validateField(name, value);
  };

  const handleSelect = (e, name) => {
    const value = e.value;
    const statusLabel = e.label;

    setFormData((prevState) => {
      const updatedState = { ...prevState, [name]: value };
      if (name === "ClientID") {
        updatedState.Currency = "";
        updatedState.CostFrequency = "";
        updatedState.Rate = "";
        updatedState.Tenure = "";
        updatedState.TenureFrequency = null;
        updatedState.Revenue = "";
      }
      return updatedState;
    });
    validateField(name, value);
    console.log("value",statusLabel);
    
    if (statusLabel !== "Open") {
     const today = new Date().toISOString().split("T")[0];

  setFormData(prev => {
    const updated = {
      ...prev,
      JobStatsChangeDate: today
    };

    // Use prev to calculate aging correctly
    calculateAging(prev.RequirementDate, today);

    return updated;
  });

  setAllowAgingCalculation(false);

  } else {
    // Status changed → NON OPEN
    setAllowAgingCalculation(false);

    // Set JobStatusChangeDate = TODAY
    const today = new Date().toISOString().split("T")[0];

    setFormData(prev => ({
      ...prev,
      JobStatsChangeDate: today
    }));

    // Now aging is based on requirement date vs TODAY
    calculateAging(
      formData.RequirementDate,
      today
    );
        setFormData(prev => ({
      ...prev,
      JobStatsChangeDate: "",
      AgingDays: ""
    }));

  }
  
  };

  const handleMultiSelect = (selectedOption, fieldName) => {
    setFormData((prevState) => {
      // Ensure selectedOption is an array and add it to the previous values
      const updatedState = {
        ...prevState,
        [fieldName]: Array.isArray(selectedOption)
          ? selectedOption // If it's already an array, just use it
          : [...prevState[fieldName], selectedOption], // Otherwise, add the selected option
      };
      return updatedState;
    });

    // Ensure you're validating the correct field
    validateField(fieldName, selectedOption);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const isValid = await validateForm();
    if (isValid) {
      setLoading(true);
      try {
        const response = await PostServiceCaller(
          `${API_URL}requirement/${id}`,
          formData,
          "put"
        );

        setLoading(false);

        // Check response and log in case of error
        if (response.status === 200) {
          toast.success("Data submitted successfully");
          setTimeout(() => {
            window.location.href = "/customer-requirement";
          }, 2000);
          setFormSubmitted(true);
        } else {
          console.error(
            "Failed to submit data. Server responded with status:",
            response.status
          );
          console.error("Response data:", response.data);
          setLoading(false);
        }
      } catch (error) {
        setLoading(false);

        console.error("Error while submitting data:", error);
        if (error.response && error.response.data) {
          // Checking for specific error data structure
          toast.error(error.response.data.error || "Something went wrong", {
            position: "top-right",
          });
          console.error("Server responded with status:", error.response.status);
          console.error("Response data:", error.response.data);
        } else {
          // General error
          toast.error("Unexpected error occurred. Please try again.", {
            position: "top-right",
          });
        }
      }
    }
  };

  // Removed hardcoded RMG_STATUS_OPTIONS

  const hiringTypeOption = [
    { value: "", label: "Select" },
    { value: "1", label: "New FTE" },
    { value: "4", label: "Internal FTE" },
    { value: "2", label: "Contracting" },
    { value: "3", label: "ALL" },
  ];

  const projectTypeOption = [
    // { value: "", label: "Select" },
    { value: "Consulting", label: "Consulting" },
    { value: "Content", label: "Content" },
    { value: "Training", label: "Training" },
  ];

  const priorityOption = [
    { value: "", label: "Select" },
    { value: "3", label: "Low" },
    { value: "2", label: "Med" },
    { value: "1", label: "High" },
  ];
  const typeOfOpeningOption = [
    { value: "", label: "Select" },
    { value: "Fresh", label: "Fresh" },
    { value: "Replacement", label: "Replacement" },
  ];
  const loctype = [
    { value: "Offshore", label: "Offshore" },
    { value: "Onsite", label: "Onsite" },
    { value: "Remote", label: "Remote" },
  ];

  const [originalFrequencyOptions, setOriginalFrequencyOptions] = useState([]);
  const [engTypeOption, setEngTypeOption] = useState([]);
  const [frequencyOption, setFrequencyOption] = useState(
    originalFrequencyOptions
  );

  const oriTenureFrequency = [
    { value: "", label: "" },
    { value: 1, label: "Day" },
    { value: 2, label: "Month" },
    { value: 3, label: "Hourly" },
  ];

  // State to store tenure frequency
  const [originalTenureFrequency, setOriginalTenureFrequency] =
    useState(oriTenureFrequency);

  // Set tenureFrequency to null by default
  const [tenureFrequency, setTenureFrequency] = useState(null);

  useEffect(() => {
    fetchCustomerRequirementfilter();
  }, []);

  const fetchCustomerRequirementfilter = async () => {
    setPageLoading(true);
    try {
      const response = await GetServiceCaller(`${API_URL}customer-filter-data`);
      if (response.status === 200) {
        setPageLoading(false);
        const jobTitleOptions = response?.data?.data?.jobtitle.map(
          (record) => ({
            value: record.value,
            label: record.text,
          })
        );
        setJobTitleOption(jobTitleOptions);
        // Client list
        const clientOptions = response?.data?.data?.client.map((record) => ({
          value: record.value,
          label: record.text,
        }));
        setClientOption(clientOptions);

        const engagementTypeOptions = response?.data?.data?.engagement_type.map(
          (record) => ({
            value: record.value,
            label: record.text,
          })
        );

        setEngTypeOption(engagementTypeOptions);

        const regionoption = response?.data?.data?.region?.map((record) => ({
          value: record?.value,
          label: record?.text,
        }));
        setRegionoption(regionoption);

        const CurrOptions = response?.data?.data?.currency.map((record) => ({
          value: record.ID,
          label: record.Name,
          symbol: record.CurrencySymbol,
        }));

        setCurrecyOption(CurrOptions);

        const reqTypeOpts = response?.data?.data?.requirement_type?.map((record) => ({
          value: record.value,
          label: record.text,
          code: record.code,
        })) || [];
        
        if (reqTypeOpts.length === 0) {
          console.warn('RequirementType options not loaded from DB. Check REQUIREMENT_TYPE master code.');
        }
        setRequirementTypeOptions(reqTypeOpts);
        
        const trackOptions = response?.data?.data?.track?.map((record) => ({
          value: record.value,
          label: record.text,
        })) || [];
        setTrackOption(trackOptions);

        const jobFamilyOptions = response?.data?.data?.job_family?.map((record) => ({
          value: record.value,
          label: record.text,
        })) || [];
        setJobFamilyOption(jobFamilyOptions);

        const experienceOptions = response?.data?.data?.experience?.map((record) => ({
          value: record.value,
          label: record.text,
        })) || [];
        setExperienceOption(experienceOptions);

        const personalAreaOptions = response?.data?.data?.personal_area?.map((record) => ({
          value: record.value,
          label: record.text,
        })) || [];
        setPersonalAreaOption(personalAreaOptions);

        const personalSubAreaOptions = response?.data?.data?.personal_sub_area?.map((record) => ({
          value: record.value,
          label: record.text,
        })) || [];
        setPersonalSubAreaOption(personalSubAreaOptions);

        const requisitionSourceOptions = response?.data?.data?.requisition_source?.map((record) => ({
          value: record.value,
          label: record.text,
        })) || [];
        setRequisitionSourceOption(requisitionSourceOptions);

        const employeeGroupOptions = response?.data?.data?.employee_group?.map((record) => ({
          value: record.value,
          label: record.text,
        })) || [];
        setEmployeeGroupOption(employeeGroupOptions);

        const billingTypeOptions = response?.data?.data?.billing_type?.map((record) => ({
          value: record.value,
          label: record.text,
        })) || [];
        setBillingTypeOption(billingTypeOptions);

        const rmgStatusOptions = response?.data?.data?.rmg_status?.map((record) => ({
          value: record.value,
          label: record.text,
        })) || [];
        setRmgStatusOption(rmgStatusOptions);

        const frequencyOptions = response?.data?.data?.frequency.map(
          (record) => ({
            value: record.value,
            label: record.text,
          })
        );

        setOriginalFrequencyOptions(frequencyOptions);

        const rompocOptions = response?.data?.data?.rompoc.map((record) => ({
          value: record.value,
          label: record.text,
        }));

        const jobStatusOptions = response?.data?.data?.jobstatus.map(
          (record) => ({
            value: record.value,
            label: record.text,
          })
        );
        setJobStatusOption(jobStatusOptions);
        const locationOptions = response?.data?.data?.location.map(
          (record) => ({
            value: record.value,
            label: record.text,
          })
        );
        setLocationOption(locationOptions);

        const skillOptions = response?.data?.data?.skills.map((record) => ({
          value: record.ID,
          label: record.Name,
        }));
        setSkillSetOptions(skillOptions);

        const subSkillData = response?.data?.data?.subskills;
        const options = subSkillData.map((subSkill) => ({
          value: subSkill.ID,
          label: subSkill.SubSkill,
        }));
        setSubSkillOptions1(options);
        setLoading(false);
      } else {
        console.error(
          "Failed to fetch partnerMaster. Server responded with status:",
          response.status
        );
      }
    } catch (error) {
      console.error("Error fetching PartnerMaster:", error);
    }
  };
  useEffect(() => {
    fetchRequirementID(id);
  }, [id]);

  const [pageLoading, setPageLoading] = useState(false);
  const fetchRequirementID = async (id) => {
    // setPageLoading(true)
    try {
      const response = await GetServiceCaller(`${API_URL}requirement/${id}`);
      if (response.status === 200) {
        setPageLoading(false);
        const data = response?.data?.data;
        const cleanedData = data?.customerrequirement?.[0];
        console.log('cleanedData',cleanedData);
        
        // Merge emplinesData, contractorlinesdata and pipelinelinesdata
        const mergedLinesData = [
          ...(data?.emplinesdata || []),
          ...(data?.contractorlinesdata || []),
          ...(data?.pipelinelinesdata || []),
        ];
        setMergeLineData(mergedLinesData);

        // Process skill and sub-skill options
        const skillData = data?.skills || [];
        const subSkillData = data?.subskills || [];

        const skillOptions = skillData.map((skill) => ({
          value: skill.ID,
          label: skill.Name,
        }));
        const subSkillOptions = subSkillData.map((subSkill) => ({
          value: subSkill.ID,
          label: subSkill.SubSkill,
        }));
        const locOptions = data.location.map((subSkill) => ({
          value: subSkill.value,
          label: subSkill.text,
        }));

        setSkillSetOptions(skillOptions);
        setSubSkillOptions(subSkillOptions);

        // Set selected skills and sub-skills
        const selectedSkills = parseSelectedOptions(
          cleanedData?.skill,
          skillOptions
        );
        const selectedSubSkills = parseSelectedOptions(
          cleanedData?.Technology,
          subSkillOptions
        );

        // Parse location and set splitLocation
        // const locationArray = cleanedData?.Location?.split("," ) || [];
        const locationArray = parseSelectedOptions(
          cleanedData?.Location,
          locOptions
        );
        setInitialBackendStatus(cleanedData.JobStatus);

        // setSplitLocation(locationArray?.map(o=> o));

        // Set initial form data
        const formData = {
          JobCode: cleanedData.JobCode,
          PositionName: cleanedData.PositionName,
          Description: cleanedData.Description,
          Technology: selectedSubSkills,
          NumOpenings: cleanedData.NumOpenings,
          OpeningType: cleanedData.OpeningType,
          RequirementHiringType: cleanedData.RequirementHiringType,
          ClientID: cleanedData.ClientID,
          LocationType: cleanedData.LocationType,
          Location: locationArray,
          MinExp: mapLegacyExperienceToRange(cleanedData.MinExp),
          MaxExp: mapLegacyExperienceToRange(cleanedData.MaxExp),
          Client_Priority: cleanedData.Client_Priority,
          Shift: cleanedData.Shift,
          RomID: cleanedData.RomID,
          HiringType: cleanedData.HiringType,
          JobStatus: cleanedData.JobStatus,
          IsInActive: cleanedData.IsInActive,
          Reason: cleanedData.Reason,
          Priority: cleanedData.Priority,
          Client_poc: cleanedData.Client_poc,
          client_Partner: "",
          Delivery_Partner: "",
          Project_Manager: "",
          Role: cleanedData.Role,
          RequirementDate: cleanedData.RequirementDate,
          BillingStartDate: cleanedData.BillingStartDate,
          skill: selectedSkills,
          ProjectType: cleanedData.ProjectType,
          AccountManager: cleanedData.AccountManager,
          Currency: cleanedData.Currency,
          CostFrequency: cleanedData.CostFrequency,
          Rate: cleanedData.Rate,
          Tenure: cleanedData.Tenure,
          TenureFrequency: cleanedData.TenureFrequency,
          Revenue: cleanedData.Revenue,
          RegionID: cleanedData.RegionID,
          JobStatsChangeDate:cleanedData.JobStatsChangeDate,
          AgingDays:cleanedData.AgingDays,
          TrackerID: cleanedData.TrackerID,
          JobFamilyID: cleanedData.JobFamilyID,
          PersonalAreaID: cleanedData.PersonalAreaID,
          PersonalSubAreaID: cleanedData.PersonalSubAreaID,
          RequisitionSourceID: cleanedData.RequisitionSourceID,
          EmployeeGroup_ID: cleanedData.EmployeeGroup_ID,
          BillingTypeID: cleanedData.BillingTypeID,
          RMGStatusID: cleanedData.RMGStatusID,
          RequirementType: cleanedData.RequirementType || (Number(cleanedData.ClientID) === 354
            ? requirementTypeOptions.find(o => o.code === 'INT')?.value
            : requirementTypeOptions.find(o => o.code === 'CUST')?.value)
        };
        setClientIdValue(cleanedData.ClientID);
        setFormData(formData);
        setLoading(false);
      } else {
        console.error(
          "Failed to fetch data. Server responded with status:",
          response.status
        );
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const internalOption = requirementTypeOptions.find(o => o.code === 'INT');
  const clientReadOnlyFlag = internalOption && (String(formData?.RequirementType) === String(internalOption.value));

  // Utility function to parse selected options
  const parseSelectedOptions = (dataString, options) => {
    return (dataString?.split(",") || [])
      .map((id) => options.find((option) => option.value === Number(id)))
      .filter(Boolean);
  };
  const JobStatusData = initialBackendStatus;
  const isDisabled = formSubmitted || Number(JobStatusData) !== 6749;

  // State initialization

  useEffect(() => {
    const mappedLocation = splitLocation
      .map((element) =>
        locationOption?.find((o) => o?.value === Number(element))
      )
      .filter(Boolean);
    // Location(mappedLocation);
    setMappLoc(mappedLocation);
  }, [splitLocation, locationOption]);

  // useEffect(() => {
  //  if(mappLoc){ setFormData((prevFormData) => ({
  //     ...prevFormData,
  //     Location: mappLoc,
  //   }))}
  // }, [mappLoc])

  useEffect(() => {
    if (formData.skill && formData.skill.length > 0) {
      // Extract the 'value' from each selected option
      const selectedValues = formData.skill.map((option) => option?.value);

      // Join the selected values into a comma-separated string
      const skillValues = selectedValues.join(",");
      // Fetch sub-skill options with the comma-separated values
      fetchSubSkillOptions(skillValues);
    } else {
      setSubSkillOptions([]);
      setFormData((prevFormData) => ({
        ...prevFormData,
        Technology: [],
      }));
    }
  }, [formData.skill]);

  const fetchSubSkillOptions = async (skill_id) => {
    try {
      let data = { skillId: skill_id };
      const response = await PostServiceCaller(
        API_URL + "fetch-subskils",
        data,
        "post"
      );
      const subSkillData = response.data;

      const options = subSkillData.map((subSkill) => ({
        value: subSkill.ID,
        label: subSkill.SubSkill,
      }));
      setSubSkillOptions(options);
    } catch (error) {
      console.error("Error fetching subSkill options:", error);
    }
  };
  const [clientIdValue, setClientIdValue] = useState(0);

  useEffect(() => {
    if (clientIdValue) {
      fetchClientId(clientIdValue);
    }
    setFormData({
      ...formData,
      RomID: "",
      RegionID:"",
      AccountManager: "",
    });
  }, [clientIdValue]);

  const [projectManagerValue, setProjectMagerValue] = useState();
  const [clientPartnerValue, setClientPartnerValue] = useState();
  const [deliveryPartnerValue, setDeliveryPartnerValue] = useState();

  {
    /**  for select list of acc manager and rompoc based on client iD */
  }
  const fetchClientId = async (id) => {
    try {
      const data = { P_ClientID: id };
      const response = await PostServiceCaller(
        API_URL + "Client-id",
        data,
        "post"
      );
      const clientData = response?.data?.ClientID;

      const clientRomPocOptions = clientData?.map((data) => ({
        label: data.RomPOC,
        value: data.RomPocID,
      }));

      // const clientRegionValue = clientData?.map((data) => ({
      //   label: data.RegionName,
      //   value: data.RegionID,
      // }));

      const clientRegionValue = clientData
        .filter((data, index, self) => 
          index === self.findIndex((d) => d.RegionID === data.RegionID)
        )
        .map((data) => ({
          label: data.RegionName,
          value: data.RegionID,
        }));
      

      const clientAccountManagerOptions = clientData?.map((data) => ({
        value: data.AccountManagerID,
        label: data.AccountManager,
      }));
      const CPValue = clientData
        ?.filter((data) => data.TypeID === 6837)
        .map((data) => data?.CRM_ManagerName);

      const DPValue = clientData
        ?.filter((data) => data.TypeID === 6836)
        .map((data) => data?.CRM_ManagerName);

      const PMValue = clientData
        ?.filter((data) => data.TypeID === 6838)
        .map((data) => data?.CRM_ManagerName);

      setClientPartnerValue(CPValue);
      setProjectMagerValue(PMValue);
      setDeliveryPartnerValue(DPValue);
      // setFormData((prevData) => ({
      //   ...prevData,
      //   client_Partner: CPValue,
      //   Delivery_Partner: DPValue,
      //   Project_Manager: PMValue,
      // }));
      setClientRegionValue(clientRegionValue);
      setClientSelectRomPoc(clientRomPocOptions);
      setClientSelectAccountManager(clientAccountManagerOptions);
      console.log("testtttt", clientRegionValue.find(
        (ele) => ele.value === formData.RegionID));

      setFormData({
        ...formData,
        RomID: clientSelectRomPoc.find(
          (ele) => ele.value === formData.RomID
        ) || null,
      });
      setFormData({
        ...formData,
        RegionID: clientRegionValue.find(
          (ele) => ele.value === formData.RegionID
        ) || null,
      });
      setFormData({
        ...formData,

        AccountManager: clientSelectAccountManager.find(
          (ele) => ele.value === clientSelectAccountManager.value
        ),
      });
    } catch (error) {
      console.error("Error fetching client options:", error);
    }
  };

  useState();

  const [showAcceptModal, setShowAcceptModal] = useState(false);
  const [modalName, setModalname] = useState("");

  useEffect(() => {
    setReason("");
  }, [showAcceptModal]);

  const handleAmendment = (ele, name) => {
    navigate(`/customer-requirement/amendment-log/${ele?.RequirementId}`);
  };

  const handleAccept = (e, name, status, ele) => {
    setModalname(name);
    setShowAcceptModal(true);
    setSelectionStatus(status);
    setSeletedListEmp(ele);
  };

  const handleModalSubmit = async (e) => {
    e.preventDefault();
    console.log("selectedlistEmp", selectedlistEmp);

    const selectID = selectedlistEmp?.ID;
    setLoading(true); // Assuming setLoading is defined
    if (selectID) {
      try {
        let response;

        // Correct condition to check for the selectedlistEmp ID

        response = await PostServiceCaller(
          `${API_URL}romcanidate-status/${selectID}`,
          {
            employeename: selectedlistEmp?.EmpName,
            role: formData?.Role,
            clientname: clientOption?.find(
              (ele) => ele?.value === formData?.ClientID
            )?.label,
            SelectionStatus: selectionStatus,
            jobcode: formData?.JobCode,
            Remarks: reason,
            Location: formData?.Location?.map((o) => o?.label).join(",") || "",
          },
          "put"
        );
        if (response.status === 200) {
          toast.success("Data submitted successfully");

          setTimeout(() => {
            setReason("");
            setSelectionStatus("");
            fetchRequirementID(id);
            // window.location.reload();
            setShowAcceptModal(false);
          }, 2000);
        } else {
          console.error(
            "Failed to submit data. Server responded with status:",
            response.status
          );
          console.error("Response data:", response.data);
        }
      } catch (error) {
        console.error("Error while submitting data:", error);
        if (
          error.response &&
          error.response.data &&
          error.response.data.error
        ) {
          toast.error(error.response.data.error, {
            position: "top-right",
          });
          console.error("Server responded with status:", error.response.status);
          console.error("Response data:", error.response.data);
        }
      } finally {
        setLoading(false);
      }
    }
  };

  const [selectionStatus, setSelectionStatus] = useState("");

  const handleAcceptModalClose = () => {
    setShowAcceptModal(false);
  };

  const [editDetailsModal, setEditDetailsModal] = useState(false);
  const [selectedlistEmp, setSeletedListEmp] = useState([]);

  const handleEditDetailsClose = () => {
    setEditDetailsModal(false);
    setBillingFormData(initialBillingData);
  };

  const [fileName, setFileName] = useState("");
  console.log('check fileName:::',fileName);
  const [resumeLink, setResumeLink] = useState("");
  console.log('check resumeLink::', resumeLink);
  
   const [file, setFile] = useState(null);
  const handleFile = (files) => {    
  if (files) {
    const selectedFile = files;
    console.log('check Files::', selectedFile);
    
const allowedTypes = [
      "application/pdf",
      "application/msword", // .doc
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document" // .docx
    ];

    if (!allowedTypes.includes(selectedFile.type)) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        resumeFile: "Only DOC, DOCX, or PDF format is allowed.",
      }));
      return;
    }

    const url = URL.createObjectURL(selectedFile);
    setFileUrl(url);
    setResumeLink(url);
    setErrors((prevErrors) => ({
      ...prevErrors,
      resumeFile: "",
    }));

    setFile(selectedFile);
    setFileName(selectedFile.name);

    setBillingFormData((prevState) => ({
      ...prevState,
      resumeFile: selectedFile, 
    }));
  } else {
    setErrors((prevErrors) => ({
      ...prevErrors,
      resumeFile:
       "Please select a valid DOC, DOCX, or PDF file.",
    }));
  }
};

  const handleEditDetails = (e, ele) => {
    e.preventDefault();
    e.stopPropagation();
    setEditDetailsModal(true);
    setSeletedListEmp(ele);
    fetchBillingDropDown(ele?.RequirementId);
    fetchBillingDetails(ele?.ID);
  };

  const [billingCurrencyOptions, setBillingCurrencyOptions] = useState([]);
  const [processStatusOptions, setProcessStatusOptions] = useState([]);
  const [romRoundOptions, setRomRoundOptions] = useState([]);
  const [frequencyOptions, setFrequencyOptions] = useState([]);

  const fetchBillingDropDown = async (id) => {
    try {
      const response = await GetServiceCaller(`${API_URL}resource/${id}`);

      if (response.status === 200) {
        const cleanedData = response.data;

        const currency = cleanedData.currency.map((ele) => ({
          value: ele.value,
          label: ele.text,
        }));

        setBillingCurrencyOptions(currency);

        const desiredOrder = [
          "Shared",
          "Scheduled",
          "Postponed",
          "Select",
          "Not Fit",
          "JD Mismatch",
          "Reject",
          "Final-Select",
          "Joined",
          "Cancelled"
        ];
        const process_status = cleanedData.processStatus.map((ele) => ({
          value: ele.value,
          label: ele.text,
        })).sort((a, b) => desiredOrder.indexOf(a.label) - desiredOrder.indexOf(b.label));
        setProcessStatusOptions(process_status);

        const getRoundPriority = (item) => {
          const numMatch = (item.label || "").match(/\d+/);
          if (numMatch) return parseInt(numMatch[0], 10);

          const idPriorityMap = {
            "6743": 1, // Level 1 (L1 Option, Database ID: 6743)
            "6744": 2, // Level 2 (L2 Option, Database ID: 6744)
            "6745": 3, // Level 3 (L3 Option, Database ID: 6745)
            "6746": 4, // Level 4 (L4 Option, Database ID: 6746)
            "6747": 5, // Level 5 (L5 Option, Database ID: 6747)
            "6748": 6  // Level 6 (L6 Option, Database ID: 6748)
          };
          return idPriorityMap[item.value] ?? 99;
        };
        const romround = cleanedData.romround.map((ele) => ({
          value: ele.value,
          label: ele.text,
        })).sort((a, b) => getRoundPriority(a) - getRoundPriority(b));
        setRomRoundOptions(romround);

        const frequency = cleanedData.frequency.map((ele) => ({
          value: ele.value,
          label: ele.text,
        }));
        setFrequencyOptions(frequency);
        fetchRequirementID(id);
        setLoading(false);
      } else {
        console.error(
          "Failed to fetch partnerMaster. Server responded with status:",
          response.status
        );
      }
    } catch (error) {
      console.error("Error fetching PartnerMaster:", error);
    }
  };
  const initialBillingData = {
    AdditionalComments: "",
    Cost: "",
    Frequency: "",
    InterviewDate: " ",
    SubmissionDate: "",
    status: "",
    currency: "",
    Round: "",
    ProjectDOJ: "",
    RequirementId: "",
    RevisionNumber: "",
    Employees: "",
    IsEmployee: 0,
    resumeFile: null,
  };
  const [billingFormData, setBillingFormData] = useState(initialBillingData);
  const handleBillingChange = (e) => {
    const { name, value } = e.target;
    setBillingFormData({ ...billingFormData, [name]: value });
  };

  const handleBillingSelect = (selectedOption, actionMeta) => {
    const { name } = actionMeta;
    const selectedValue = selectedOption ? selectedOption.value : "";
    setBillingFormData({ ...billingFormData, [name]: selectedValue });
  };

  const [isbBillingStatusChange, setIsbBillingStatusChange] = useState(0);
  const handleBillingSubmit = async (e) => {
    e.preventDefault();
      const payload = {
      ...billingFormData,
      clientname: clientOption?.find((o) => o.value === formData?.ClientID)?.label,
      role: formData?.Role,
      Location: formData?.Location?.map((o) => o?.label).join(",") || "",
      RequirementId: selectedlistEmp?.RequirementId,
      Employees: selectedlistEmp?.Employees,
      IsEmployee: selectedlistEmp?.Type === "Pipeline" || Number(selectedlistEmp?.IsEmployee) === 3
        ? 3
        : (selectedlistEmp?.Type === "Employee" || Number(selectedlistEmp?.IsEmployee) === 1 ? 1 : 2),
      jobcode: formData?.JobCode,
      emailkey: isbBillingStatusChange,
    };    
    setLoading(true); // Assuming setLoading is defined
    try {
      let response;

      // Correct condition to check for the selectedlistEmp ID
      if (selectedlistEmp?.ID !== undefined && selectedlistEmp?.ID !== "") {
        response = await PostFormServiceCaller(
          `${API_URL}resource-billing/${selectedlistEmp?.ID}`,
         payload,
          "put"
        );
      } else {
        response = await PostFormServiceCaller(
          `${API_URL}resource-billing`,
          payload,
          "post"
        );
      }

      if (response.status === 200) {
        toast.success("Data submitted successfully");

        setTimeout(() => {
          setEditDetailsModal(false);
          setBillingFormData(initialBillingData);
          window.location.reload();
        }, 2000);
        setBillingFormData({});

        // response = await PostServiceCaller(
        //   `${API_URL}romcandidatemail`,
        //   {
        //     status: billingFormData?.status,
        //     role: formData?.Role,
        //     clientname:
        //       clientOption.find((ele) => ele?.value === formData?.ClientID)
        //         ?.label || "",
        //     employeename: selectedlistEmp?.EmpName,
        //   },
        //   "post"
        // );
      } else {
        console.error(
          "Failed to submit data. Server responded with status:",
          response.status
        );
        console.error("Response data:", response.data);
      }
    } catch (error) {
      console.error("Error while submitting data:", error);
      if (error.response && error.response.data && error.response.data.error) {
        toast.error(error.response.data.error, {
          position: "top-right",
        });
        console.error("Server responded with status:", error.response.status);
        console.error("Response data:", error.response.data);
      }
    } finally {
      setLoading(false);
    }
  };

  const fetchBillingDetails = async (employeeId) => {
    try {
      const response = await GetServiceCaller(
        `${API_URL}resource-billing/${employeeId}`
      );
      if (response.status === 200) {
        const cleanedData = response.data.resource;
        
        setBillingFormData({
          AdditionalComments: cleanedData?.[0]?.AdditionalComments,
          Cost: cleanedData?.[0]?.Cost,
          Frequency: cleanedData?.[0]?.Frequency,
          InterviewDate:
            cleanedData?.[0]?.InterviewDate !== null
              ? moment(cleanedData?.[0]?.InterviewDate).format("DD-MMM-YYYY")
              : "",
          SubmissionDate: cleanedData?.[0]?.SubmissionDate
            ? moment(cleanedData?.[0]?.SubmissionDate).format("DD-MMM-YYYY")
            : "",
          status: cleanedData?.[0]?.status,
          RevisionNumber: cleanedData?.[0]?.RevisionNumber,

          currency: cleanedData?.[0]?.currency,
          Round: cleanedData?.[0]?.Round,
          ProjectDOJ: cleanedData?.[0]?.ProjectDOJ
            ? moment(cleanedData?.[0]?.ProjectDOJ).format("DD-MMM-YYYY")
            : "",
          RequirementId: cleanedData?.[0]?.RequirementId,
          Employees: cleanedData?.[0]?.Employees,
          IsEmployee: cleanedData?.[0]?.IsEmployee,
          resumeFile: cleanedData?.[0]?.ResumeBasePath,
        });
        setFileName(cleanedData?.[0]?.ResumePath);
        setResumeLink(cleanedData?.[0]?.ResumeBasePath);
        setLoading(false);
      } else {
        console.error(
          "Failed to fetch partnerMaster. Server responded with status:",
          response.status
        );
      }
    } catch (error) {
      console.error("Error fetching PartnerMaster:", error);
    }
  };

  const [reason, setReason] = useState("");

  const handleReasonChange = (e) => {
    const { name, value } = e.target;
    setReason(value);
  };

  const clientPriorityOptions = [
    // { value: 0, label: "Select" },
    { value: 1, label: "Hot" },
    { value: 2, label: "Cold" },
    { value: 3, label: "Warm" },
  ];

  useEffect(() => {
    if (formData?.HiringType == null) return; // Ensure HiringType is available
    const updatedFrequencyOptions = (() => {
      if (formData.HiringType === 6753) {
        return originalFrequencyOptions.filter((option) =>
          [1531, 1530, 1529].includes(option.value)
        );
      } else if (formData.HiringType === 6754) {
        return originalFrequencyOptions.filter((option) =>
          [1532].includes(option.value)
        );
      } else if (formData.HiringType === 6835) {
        return originalFrequencyOptions.filter((option) =>
          [1532, 1530, 1529].includes(option.value)
        );
      } else if (formData.HiringType === 6755) {
        return originalFrequencyOptions.filter((option) =>
          [1531, 1532, 1530, 1529].includes(option.value)
        );
      }
      return originalFrequencyOptions;
    })();
    setFrequencyOption(updatedFrequencyOptions);
  }, [formData?.HiringType, originalFrequencyOptions]); // Ensure it re-runs when options change

  // Original tenure frequency options
  useEffect(() => {
    if (!formData?.CostFrequency) {
      setTenureFrequency([]);
      return;
    }

    // Set options based on CostFrequency value
    const updatedTenureFrequencyOptions = (() => {
      if (formData?.CostFrequency === 1531) {
        return originalTenureFrequency.filter((option) =>
          [1].includes(option.value)
        ); // Show only "Day"
      } else if (formData?.CostFrequency === 1532) {
        return originalTenureFrequency.filter((option) =>
          [1, 2].includes(option.value)
        ); // Show "Day" and "Month"
      } else if (formData?.CostFrequency === 1530) {
        return originalTenureFrequency.filter((option) =>
          [3].includes(option.value)
        ); // Show "Hourly"
      } else if (formData?.CostFrequency === 1529) {
        return originalTenureFrequency.filter((option) =>
          [2].includes(option.value)
        ); // Show "Month"
      }
      return originalTenureFrequency; // Default case (if needed)
    })();

    setTenureFrequency(updatedTenureFrequencyOptions);
  }, [formData?.CostFrequency]);

  const revenueCalculation = () => {
    if (
      formData.HiringType === 6753 ||
      formData.HiringType === 6755 ||
      formData.HiringType === 6835
    ) {
      // TNM//poc//adhoc
      if (
        (formData.CostFrequency === 1531 && formData.TenureFrequency === 1) ||
        (formData.CostFrequency === 1529 && formData.TenureFrequency === 2) ||
        (formData.CostFrequency === 1530 && formData.TenureFrequency === 3)
      ) {
        const revenues =
          Number(formData.Tenure) *
          Number(formData.Rate) *
          Number(formData.NumOpenings);
        setFormData({ ...formData, Revenue: revenues });
      }
      if (formData.CostFrequency === 1532) {
        // fixed rate

        const revenues = Number(formData.Rate);
        // *                                    // do not remove this commented code
        // Number(formData.NumOpenings);
        setFormData({ ...formData, Revenue: revenues });
      }
    }
  };

  const calculateAging = (requirementDate, statusChangeDate) => {
  if (!requirementDate || !statusChangeDate) return;

  const req = new Date(requirementDate);
  const change = new Date(statusChangeDate);

  const diffDays = Math.floor(
    (change - req) / (1000 * 60 * 60 * 24)
  );

  setFormData(prev => ({
    ...prev,
    AgingDays: diffDays
  }));
};


  useEffect(() => {
    revenueCalculation();
  }, [
    formData.TenureFrequency,
    formData.Tenure,
    formData.CostFrequency,
    formData.Currency,
    formData.HiringType,
    formData.Rate,
    formData.NumOpenings,
  ]);

  // Add this early in your app's lifecycle (e.g., in index.js)

  if (pageLoading) {
    return (
      <p className="position-absolute top-50 start-50 translate-middle text-center">
        <FaSpinner className="spinner" />
      </p>
    );
  }
  return (
    <>
      <div className="Container">
        <form
          id="formOne"
          className="rounded mt-2 bg-white"
          onSubmit={handleSubmit}
        >
          <div className="mx-3">
            <div className="row row-flex">
              {/* grid one start */}
              <div className="col-md-9 flex-col mt-1">
                <div className="card-body">
                  <div className="row mt-2">
                    <div className="col-sm-2">
                      <label className="form-label">Job Code</label>
                      <input
                        name="JobCode"
                        type="text"
                        readOnly
                        disabled
                        className="form-control"
                        id="JobCode"
                        value={formData.JobCode}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="col-sm-2">
                      <label className="form-label">
                        Date<span className="text-danger ">*</span>
                      </label>
                      <CustomDatePicker
                        // handleChange={(e) => handleReqDate(e)}
                        handleChange={(e) => handleChange(e)}
                        value={moment(formData.RequirementDate).format(
                          "DD-MM-YYYY"
                        )}
                        name="RequirementDate"
                        className="form-control"
                        placeholderText="DD-MM-YYYY"
                      />
                    </div>
                    <div className="col-sm-2">
                      <label className="form-label">
                        Billing Start Date{!clientReadOnlyFlag && <span className="text-danger ">*</span>}
                      </label>
                      <CustomDatePicker
                        handleChange={(e) => handleChange(e)}
                        value={formData.BillingStartDate ? moment(formData.BillingStartDate).format("DD-MM-YYYY") : ""}
                        name="BillingStartDate"
                        className={`form-control ${errors?.BillingStartDate ? "is-invalid" : ""}`}
                        placeholderText="DD-MM-YYYY"
                      />
                      <span class="error">{errors?.BillingStartDate}</span>
                    </div>
                    <div className="col-sm-3">
                      <label className="form-label">Job Title</label>
                      <Select
                        name="PositionName"
                        onChange={(selectedOption, action) =>
                          handleSelect(selectedOption, action.name)
                        }
                        options={jobTitleOption}
                        value={jobTitleOption.find(
                          (ele) => ele.value === Number(formData.PositionName)
                        )}
                      />
                    </div>
                    <div className="col-sm-3">
                      <label className="form-label">
                        Role<span className="text-danger ">*</span>
                      </label>
                      <input
                        type="text"
                        // className={`form-control`}
                        name="Role"
                        className={`form-control ${
                          errors?.Role ? "is-invalid" : ""
                        }`}
                        onChange={handleChange}
                        value={formData.Role}
                      />
                      <span class="error">{errors?.Role}</span>
                    </div>
                  </div>
                  <div className="row mt-2">
                    <div className="col-sm-2">
                      <label className="form-label">Job Status</label>
                      <Select
                        name="JobStatus"
                        isDisabled={isDisabled}
                        // onChange={handleSelectChange}
                        onChange={(selectedOption, action) =>
                          handleSelect(selectedOption, action.name)
                        }
                        options={jobStatusOption}
                        value={jobStatusOption.find(
                          (ele) => ele.value == Number(formData.JobStatus)
                        )}
                      />
                    </div>
                    <div className="col-sm-3">
                      <label className="form-label">
                        Client<span className="text-danger">*</span>
                      </label>
                      <Select
                        name="ClientID"
                        className={` ${errors?.ClientID ? "is-invalid" : ""}`}
                        onChange={(selectClient, actionMeta) => {
                          handleSelect(selectClient, actionMeta.name);
                          setClientIdValue(selectClient.value);
                        }}
                        options={clientOption}
                        value={clientOption.find(
                          (ele) => ele.value == Number(formData.ClientID)
                        )}
                      />
                      <span class="error">{errors?.ClientID}</span>
                    </div>
                    <div className="col-sm-3">
                      <label className="form-label">
                        Requirement Type<span className="text-danger">*</span>
                      </label>
                      <div className="d-flex align-items-center mt-2" style={{ gap: '15px' }}>
                        {requirementTypeOptions.map((opt) => (
                          <div className="form-check form-check-inline m-0" key={opt.value}>
                            <input
                              className="form-check-input"
                              type="radio"
                              name="RequirementType"
                              id={`reqType_${opt.value}`}
                              value={opt.value}
                              style={{ cursor: "pointer" }}
                              checked={String(formData.RequirementType) === String(opt.value)}
                              onChange={handleChange}
                            />
                            <label className="form-check-label ms-1" htmlFor={`reqType_${opt.value}`} style={{ cursor: "pointer" }}>
                              {opt.label}
                            </label>
                          </div>
                        ))}
                      </div>
                    </div>
                    <div className="col-sm-2">
                      <label className="form-label">Client POC</label>
                      <input
                        type="text"
                        className="form-control"
                        name="Client_poc"
                        onChange={handleChange}
                        value={formData.Client_poc}
                      />
                    </div>
                    <div className="col-sm-2">
                      <label className="form-label">
                        Client Priority<span className="text-danger ">*</span>
                      </label>
                      <Select
                        name="Client_Priority"
                        // onChange={handleSelectChange}
                        className={` ${
                          errors?.Client_Priority ? "is-invalid" : ""
                        }`}
                        onChange={(e, action) => handleSelect(e, action.name)}
                        options={clientPriorityOptions}
                        value={clientPriorityOptions.find(
                          (ele) => ele.value == Number(formData.Client_Priority)
                        )}
                      />
                      <span class="error">{errors?.Client_Priority}</span>
                    </div>
                  </div>
                  <div className="row mt-2">
                    <div className="col-sm-3">
                      <label className="form-label">
                        RMG Priority<span className="text-danger">*</span>
                      </label>
                      <Select
                        name="Priority"
                        // onChange={(selectClient, actionMeta) => {
                        //   handleSelectChange(selectClient, actionMeta);
                        // }}

                        onChange={(prio, action) =>
                          handleSelect(prio, action.name)
                        }
                        options={priorityOption}
                        value={priorityOption.find(
                          (ele) => ele.value == formData.Priority
                        )}
                      />
                    </div>
                       <div className="col-sm-3">
                      <label className="form-label">
                        Hiring Type<span className="text-danger ">*</span>
                      </label>
                      <Select
                        name="RequirementHiringType"
                        // onChange={handleSelectChange}
                        onChange={(selectedOption, action) =>
                          handleSelect(selectedOption, action.name)
                        }
                        className={` ${
                          errors?.RequirementHiringType ? "is-invalid" : ""
                        }`}
                        options={hiringTypeOption}
                        value={hiringTypeOption.find(
                          (ele) =>
                            ele.value == Number(formData.RequirementHiringType)
                        )}
                      />{" "}
                      <span class="error">{errors?.RequirementHiringType}</span>
                    </div>
                    <div className="col-sm-3">
                      <label className="form-label">Type of Opening</label>
                      <Select
                        name="OpeningType"
                        // onChange={handleSelectChange}
                        onChange={(selectedOption, action) =>
                          handleSelect(selectedOption, action.name)
                        }
                        options={typeOfOpeningOption}
                        value={typeOfOpeningOption.find(
                          (ele) => ele.value === formData.OpeningType
                        )}
                      />
                    </div>
                    <div className="col-sm-3">
                      <label className="form-label">
                        Openings #<span className="text-danger ">*</span>
                      </label>
                      <input
                        type="text"
                        className={`form-control text-end ${
                          errors?.NumOpenings ? "is-invalid" : ""
                        }`}
                        name="NumOpenings"
                        placeholder="No of Opening"
                        onChange={handleChange}
                        value={formData.NumOpenings}
                        readOnly
                      />
                      <span class="error">{errors?.NumOpenings}</span>
                    </div>
                  </div>
                     <div className="row mt-2">
                    <div className="col-sm-3">
                      <label className="form-label">
                        Total Exp.<span className="text-danger ">*</span>
                      </label>
                      <Select
                        name="MaxExp"
                        className={`form-control-select ${errors?.MaxExp ? "is-invalid" : ""}`}
                        onChange={(selectedOption, action) =>
                          handleSelect(selectedOption, action.name)
                        }
                        options={experienceOptions}
                        value={experienceOptions.find((o) => o.value === formData.MaxExp) || null}
                      />
                    </div>
                    <div className="col-sm-3">
                      <label className="form-label">
                        Relevant Exp.<span className="text-danger ">*</span>
                      </label>
                      <Select
                        name="MinExp"
                        className={`form-control-select ${errors?.MinExp ? "is-invalid" : ""}`}
                        onChange={(selectedOption, action) =>
                          handleSelect(selectedOption, action.name)
                        }
                        options={experienceOptions}
                        value={experienceOptions.find((o) => o.value === formData.MinExp) || null}
                      />{" "}
                      <span class="error">{errors?.MinExp}</span>
                    </div>
                    <div className="col-sm-3">
                      <label className="form-label">
                        Engagement Type<span className="text-danger ">*</span>
                      </label>
                      <Select
                        name="HiringType"
                        // onChange={handleSelectChange}
                        onChange={(selectedOption, action) =>
                          handleSelect(selectedOption, action.name)
                        }
                        className={` ${errors?.HiringType ? "is-invalid" : ""}`}
                        options={engTypeOption}
                        value={engTypeOption?.find(
                          (o) => o?.value === Number(formData?.HiringType)
                        )}
                      />{" "}
                      <span class="error">{errors?.HiringType}</span>
                    </div>
                    <div className="col-sm-3">
                      <label className="form-label">Project Type</label>
                      <Select
                        name="ProjectType"
                        // onChange={handleSelectChange}
                        onChange={(selectedOption, action) =>
                          handleSelect(selectedOption, action.name)
                        }
                        options={projectTypeOption}
                        value={projectTypeOption.find(
                          (ele) => ele.value === formData.ProjectType
                        )}
                      />
                    </div>
                  </div>
                  <div className="row mt-2">
                    <div className="col-sm-3">
                      <label className="form-label">Shift Timing</label>
                      <input
                        type="text"
                        className={`form-control`}
                        name="Shift"
                        onChange={handleChange}
                        value={formData.Shift}
                      />
                    </div>
                    <div className="col-sm-3">
                      <label className="form-label">Location Type</label>
                      <Select
                        name="LocationType"
                        // onChange={handleSelectChange}
                        onChange={(selectedOption, action) => {
                          handleSelect(selectedOption, action.name);
                        }}
                        options={loctype}
                        value={loctype.find(
                          (ele) => ele.value === formData.LocationType
                        )}
                      />
                    </div>
                    <div className="col-sm-3">
                      <label className="form-label">
                        Location<span className="text-danger ">*</span>
                      </label>

                      <Select
                        menuShouldScrollIntoView={true}
                        isMulti
                        styles={customStyle}
                        name="Location"
                        className={`basic-multi-select ${
                          errors?.Location ? "is-invalid" : ""
                        }`}
                        classNamePrefix="select"
                        // onChange={(selectedLocation) => {
                        //   setLocationValue(selectedLocation);
                        //   setFormData({
                        //     ...formData,
                        //     Location: locationValue,
                        //   });
                        // }}

                        onChange={(e) => {
                          handleMultiSelect(e, "Location");
                          // Location((prevValue) => [...prevValue, ...e]);  // Correctly spread and append the selected values
                        }}
                        value={formData?.Location}
                        options={locationOption}
                      />
                      <span class="error">{errors?.Location}</span>
                    </div>
                    <div className="col-sm-3">
                      <label className="form-label">
                        Skills <span className="text-danger">*</span>
                      </label>
                      <Select
                        isMulti
                        name="skill"
                        className="basic-multi-select"
                        classNamePrefix="select"
                        onChange={(e) => handleMultiSelect(e, "skill")}
                        styles={customStyle}
                        options={skillSetOptions}
                        value={formData.skill}
                      />
                      <span className="error">{errors?.skill}</span>
                    </div>
                  </div>
                  <div className="row mt-2">
                    <div className="col-sm-3">
                      <label className="form-label">RMG POC</label>
                      <Select
                        name="RomID"
                        onChange={(selected, action) =>
                          handleSelect(selected, action.name)
                        }
                        options={clientSelectRomPoc}
                        value={clientSelectRomPoc?.find(o => o.value == formData?.RomID)}
                      />
                    </div>

                    <div className="col-sm-3">
                      <label className="form-label">A/C Manager</label>
                      <Select
                        name="AccountManager"
                        onChange={(selectedOption, action) =>
                          handleSelect(selectedOption, action.name)
                        }
                        options={clientSelectAccountManager}
                        value={clientSelectAccountManager}
                      />
                    </div>
                 <div className="col-sm-3">
                      <label className="form-label">Client Partner</label>
                      <input
                        type="text"
                        className="form-control"
                        disabled
                        value={clientPartnerValue}
                        readOnly
                      />
                      {/* <span className="error">{errors?.ClientID}</span> */}
                    </div>
                    <div className="col-sm-3">
                      <label className="form-label">Delivery Partner</label>
                      <input
                        type="text"
                        className="form-control"
                        disabled
                        value={deliveryPartnerValue}
                        readOnly
                      />
                      {/* <span className="error">{errors?.ClientID}</span> */}
                    </div>
                  </div>
          

                    <div className="row mt-4">
                      <div className="col-sm-3">
                        <label className="form-label">
                          Currency
                          {/* Only show the red asterisk if the field is NOT read-only */}
                          {!clientReadOnlyFlag && <span className="text-danger">*</span>}
                        </label>
                        
                        <Select
                          name="Currency"
                          // onChange={handleSelectChange}
                          
                          /* FIX 1: Custom dropdown components use 'isDisabled' to freeze selection */
                          isDisabled={clientReadOnlyFlag}
                          
                          /* FIX 2: Only trigger state changes if the field is NOT read-only */
                          onChange={(selectedOption, action) => {
                            if (!clientReadOnlyFlag) {
                              handleSelect(selectedOption, action.name);
                            }
                          }}
                          
                          /* FIX 3: Add 'pe-none' when locked to prevent mouse interaction, and hide 'is-invalid' border */
                          className={`${clientReadOnlyFlag ? "pe-none" : ""} ${
                            (!clientReadOnlyFlag && errors?.Currency) ? "is-invalid" : ""
                          }`}
                          options={currecyOption}
                          value={currecyOption?.find(
                            (o) => o?.value === formData?.Currency
                          )}
                        />
                        
                        {/* Only show the validation error text if the field is active */}
                        {!clientReadOnlyFlag && <span className="error">{errors?.Currency}</span>}
                      </div>
                      <div className="col-sm-3">
                        <label className="form-label">
                          Cost Frequency
                          {/* Only show the red asterisk if the field is NOT read-only */}
                          {!clientReadOnlyFlag && <span className="text-danger">*</span>}
                        </label>
                        
                        <Select
                          name="CostFrequency"
                          // onChange={handleSelectChange}
                          
                          /* FIX 1: Use isDisabled for the custom dropdown to freeze selection */
                          isDisabled={clientReadOnlyFlag}
                          
                          /* FIX 2: Prevent state changes entirely when clientReadOnlyFlag is active */
                          onChange={(selectedOption, action) => {
                            if (!clientReadOnlyFlag) {
                              handleSelect(selectedOption, action.name);
                            }
                          }}
                          
                          /* FIX 3: Dynamic classes: add 'pe-none' to block clicks, and only show 'is-invalid' if not read-only */
                          className={`${clientReadOnlyFlag ? "pe-none" : ""} ${
                            (!clientReadOnlyFlag && errors?.CostFrequency) ? "is-invalid" : ""
                          }`}
                          value={frequencyOption?.find(
                            (o) => o?.value === formData?.CostFrequency
                          )}
                          options={frequencyOption}
                        />{" "}
                        
                        {/* Only show the error message layout if the field is active */}
                        {!clientReadOnlyFlag && <span className="error">{errors?.CostFrequency}</span>}
                      </div>
                      <div className="col-sm-3">
                        <label className="form-label">
                          Rate
                          {/* Only show the red asterisk if the field is NOT read-only */}
                          {!clientReadOnlyFlag && <span className="text-danger">*</span>}
                        </label>
                        <input
                          type="number"
                          name="Rate"
                          
                          /* FIX 1: Apply standard HTML readOnly attribute */
                          readOnly={clientReadOnlyFlag}
                          
                          /* FIX 2: Safely disable the onChange trigger when read-only is active */
                          onChange={clientReadOnlyFlag ? undefined : handleChange}
                          
                          /* FIX 3: Add 'bg-light' to gray it out, 'pe-none' to block clicks, and hide 'is-invalid' if read-only */
                          className={`form-control ${clientReadOnlyFlag ? "bg-light pe-none" : ""} ${
                            (!clientReadOnlyFlag && errors?.Rate) ? "is-invalid" : ""
                          }`}
                          value={formData.Rate}
                          
                          /* FIX 4: Prevent keyboard users from tabbing into the field when locked */
                          tabIndex={clientReadOnlyFlag ? -1 : 0}
                        />
                        
                        {/* Only show the error message layout if the field is active */}
                        {!clientReadOnlyFlag && <span className="error">{errors?.Rate}</span>}
                      </div>
                      <div className="col-sm-3">
                        <label className="form-label">
                          Tenure
                          {/* Only show the red asterisk if the field is NOT read-only */}
                          {!clientReadOnlyFlag && <span className="text-danger">*</span>}
                        </label>
                        <input
                          type="number"
                          name="Tenure"
                          value={formData.Tenure}
                          
                          /* FIX 1: Apply standard HTML readOnly attribute */
                          readOnly={clientReadOnlyFlag}
                          
                          /* FIX 2: Safely disable the onChange trigger when read-only is active */
                          onChange={clientReadOnlyFlag ? undefined : handleChange}
                          
                          /* FIX 3: Add 'bg-light' to gray it out, 'pe-none' to block clicks, and hide 'is-invalid' if read-only */
                          className={`form-control ${clientReadOnlyFlag ? "bg-light pe-none" : ""} ${
                            (!clientReadOnlyFlag && errors?.Tenure) ? "is-invalid" : ""
                          }`}
                          
                          /* FIX 4: Prevent keyboard users from tabbing into the field when locked */
                          tabIndex={clientReadOnlyFlag ? -1 : 0}
                        />{" "}
                        
                        {/* Only show the error message layout if the field is active */}
                        {!clientReadOnlyFlag && <span className="error">{errors?.Tenure}</span>}
                      </div>
                    </div>
                  <div className="row mt-2">
                      <div className="col-sm-3">
                        <label className="form-label">
                          Revenue
                          {/* Only show the red asterisk if the field is NOT read-only */}
                          {!clientReadOnlyFlag && <span className="text-danger">*</span>}
                        </label>
                        <div className="d-flex align-items-center">
                          <input
                            type="text"
                            id="revenue"
                            name="Revenue"
                            
                            /* FIX 1: Tie the readOnly attribute dynamically to your flag */
                            readOnly={clientReadOnlyFlag}
                            value={`${formData.Revenue} ${
                              currecyOption?.find(
                                (o) => o?.value === formData?.Currency
                              )?.symbol || ""
                            }`}
                            
                            /* FIX 2: Safely disable the onChange handler when read-only is active */
                            onChange={clientReadOnlyFlag ? undefined : handleChange}
                            
                            /* FIX 3: Add 'bg-light' to gray it out, 'pe-none' to block clicks, and hide 'is-invalid' if read-only */
                            className={`form-control me-2 ${clientReadOnlyFlag ? "bg-light pe-none" : ""} ${
                              (!clientReadOnlyFlag && errors?.Revenue) ? "is-invalid" : ""
                            }`}
                            
                            /* FIX 4: Prevent keyboard users from tabbing into the field when locked */
                            tabIndex={clientReadOnlyFlag ? -1 : 0}
                          />
                          {/* <span className="currency-label fw-bold">
                              {currecyOption?.find(
                                (o) => o?.value === formData?.Currency
                              )?.label || "No currency"}
                            </span> */}
                        </div>
                        
                        {/* Only show the error message layout if the field is active */}
                        {!clientReadOnlyFlag && <span className="error">{errors?.Revenue}</span>}
                      </div>
                    <div className="col-sm-3">
                      <label className="form-label">Region</label>
                      <Select
                        name="RegionID"
                        onChange={(e, action) => handleSelect(e, action.name)}
                        options={regionoption}
                        value={regionoption.find(
                          (o) => o.value == formData.RegionID
                        )}
                        className={`form-control-select ${errors?.RegionID ? "is-invalid" : ""}`}
                        isDisabled={String(formData.RequirementHiringType) === "4"}
                      />
                    </div>
                     <div className="col-sm-3 ">
                      <label className="form-label">
                        Job Status Change Date
                      </label>
                      <CustomDatePicker
                            handleChange={(e) => handleChange(e)}
                            value={moment(formData.JobStatsChangeDate).format(
                          "DD-MM-YYYY"
                        )}
                            readOnly={!allowAgingCalculation}
                            name="JobStatsChangeDate"
                            onChange={(e) => {
                              const value = e.target.value;
                              setFormData(prev => {
                                const requirementDate = prev.RequirementDate;
                                const updated = {
                                  ...prev,
                                  JobStatsChangeDate: value
                                };

                                // Now prev is defined – safe to use
                                calculateAging(requirementDate, value);

                                return updated;
                              });
                            }}
                            placeholderText="DD-MMM-YYYY"
                          />
                    </div>
                     <div className="col-sm-3">
                      <label className="form-label">Aging</label>
                      <input
                        type="text"
                        className="form-control"
                        disabled
                        value={formData.AgingDays}
                        readOnly
                      />
                      {/* <span class="error">{errors?.ClientID}</span> */}
                    </div>
                    <div className="col-md-3">
                      <label className="form-label">Track{String(formData.RequirementHiringType) !== "4" && <span className="text-danger">*</span>}</label>
                      <Select
                        name="TrackerID"
                        onChange={(e, action) => handleSelect(e, action.name)}
                        value={trackOption.find((o) => o.value == formData.TrackerID)}
                         className={`form-control-select ${errors?.TrackerID ? "is-invalid" : ""}`} isDisabled={String(formData.RequirementHiringType) === "4"} 
                        options={trackOption}
                      />
                    </div>
                    <div className="col-md-3">
                      <label className="form-label">Job Family{String(formData.RequirementHiringType) !== "4" && <span className="text-danger">*</span>}</label>
                      <Select
                        name="JobFamilyID"
                        onChange={(e, action) => handleSelect(e, action.name)}
                        value={jobFamilyOption.find((o) => o.value == formData.JobFamilyID)}
                         className={`form-control-select ${errors?.JobFamilyID ? "is-invalid" : ""}`} isDisabled={String(formData.RequirementHiringType) === "4"} 
                        options={jobFamilyOption}
                      />
                    </div>
                      <div className="col-md-3">
                        <label className="form-label">Personal Sub Area{String(formData.RequirementHiringType) !== "4" && <span className="text-danger">*</span>}</label>
                        <Select
                          name="PersonalSubAreaID"
                          onChange={(e, action) => handleSelect(e, action.name)}
                          value={personalSubAreaOption.find((o) => o.value == formData.PersonalSubAreaID)}
                           className={`form-control-select ${errors?.PersonalSubAreaID ? "is-invalid" : ""}`} isDisabled={String(formData.RequirementHiringType) === "4"} 
                          options={personalSubAreaOption}
                        />
                      </div>
                      <div className="col-md-3">
                        <label className="form-label">Requisition Source{String(formData.RequirementHiringType) !== "4" && <span className="text-danger">*</span>}</label>
                        <Select
                          name="RequisitionSourceID"
                          onChange={(e, action) => handleSelect(e, action.name)}
                          value={requisitionSourceOption.find((o) => o.value == formData.RequisitionSourceID)}
                           className={`form-control-select ${errors?.RequisitionSourceID ? "is-invalid" : ""}`} isDisabled={String(formData.RequirementHiringType) === "4"} 
                          options={requisitionSourceOption}
                        />
                      </div>

                      <div className="col-md-3 mt-2">
                        <label className="form-label">Billing Type{String(formData.RequirementHiringType) !== "4" && <span className="text-danger">*</span>}</label>
                        <Select
                          name="BillingTypeID"
                          onChange={(e, action) => handleSelect(e, action.name)}
                          value={billingTypeOption.find((o) => o.value == formData.BillingTypeID) || null}
                          className={`form-control-select ${errors?.BillingTypeID ? "is-invalid" : ""}`}
                          isDisabled={String(formData.RequirementHiringType) === "4"}
                          options={billingTypeOption}
                        />
                        <span  className={`form-control-select ${errors?.BillingTypeID ? "is-invalid" : ""}`}>{errors?.BillingTypeID}</span>
                      </div>
                      <div className="col-md-3 mt-2">
                        <label className="form-label">RMG Status</label>
                        <Select
                          name="RMGStatusID"
                          className={`form-control-select ${errors?.RMGStatusID ? "is-invalid" : ""}`}
                          onChange={(selectedOption, action) =>
                            handleSelect(selectedOption, action.name)
                          }
                          value={rmgStatusOption?.find(
                            (o) => String(o.value) === String(formData.RMGStatusID)
                          )}
                          options={rmgStatusOption}
                        />
                      </div>

                  </div>
                </div>
              </div>
              <div className="col-md-3">
                <div className="row mt-2">
                  <div className="col-sm-12">
                    <label className="form-label">Remark Reg. Job Status</label>
                    <div className="d-flex align-items-center">
                      <textarea
                          id="Reason"
                          name="Reason"
                          className="form-control me-2"
                          style={{ textAlign: "left", resize: "none" }}
                          rows={5}
                          onChange={handleChange}
                          value={formData.Reason}
                      />
                    </div>
                  </div>
                </div>
                <div className="row mt-3">
                  <label className="form-label">
                    Description <span className="text-danger">*</span>
                  </label>
                  <EditorComponent
                    data={formData.Description || ""}
                    onEditorChange={(content) =>
                      setFormData({ ...formData, Description: content })
                    }
                  />
                </div>
                <div className="row mt-4">
                  <div className="col-md-12">
                    <label className="form-label">
                      SubSkills <span className="text-danger">*</span>
                    </label>
                    <Select
                      isMulti
                      name="Technology"
                      className="basic-multi-select"
                      classNamePrefix="select"
                      styles={customStyle}
                      onChange={(e) => handleMultiSelect(e, "Technology")}
                      value={formData.Technology}
                      options={subSkillOptions}
                    />
                    <span className="error">{errors?.Technology}</span>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-12">
                    <label className="form-label">Project Manager</label>
                    <input
                      type="text"
                      className="form-control"
                      disabled
                      value={projectManagerValue}
                      readOnly
                    />
                  </div>
                  {/* <span className="error">{errors?.ClientID}</span> */}
                </div>
                  <div className="row mt-4">
                    <div className="col-md-12">
                      <label className="form-label">
                        Tenure Frequency
                        {/* Only show the red asterisk if the field is NOT read-only */}
                        {!clientReadOnlyFlag && <span className="text-danger">*</span>}
                      </label>
                      <Select
                        name="TenureFrequency"
                        value={tenureFrequency?.find(
                          (o) => o?.value === formData?.TenureFrequency
                        )}
                        
                        /* FIX 1: Freeze selection for the custom dropdown using isDisabled */
                        isDisabled={clientReadOnlyFlag}
                        
                        /* FIX 2: Prevent state logic changes entirely when read-only is active */
                        onChange={(selectedOption, action) => {
                          if (!clientReadOnlyFlag) {
                            handleSelect(selectedOption, action.name);
                          }
                        }}
                        
                        /* FIX 3: Add 'pe-none' to block interaction, and hide the 'is-invalid' border if read-only */
                        className={`${clientReadOnlyFlag ? "pe-none" : ""} ${
                          (!clientReadOnlyFlag && errors?.TenureFrequency) ? "is-invalid" : ""
                        }`}
                        isDisabled={clientReadOnlyFlag}
                        options={tenureFrequency}
                      />{" "}
                      
                      {/* Only show the validation error text if the field is active */}
                      {!clientReadOnlyFlag && <span className="error">{errors?.TenureFrequency}</span>}
                    </div>
                  </div>
                <div className="row mt-2">
                  <div className="col-sm-12">
                    <label className="form-label">Personal Area{String(formData.RequirementHiringType) !== "4" && <span className="text-danger">*</span>}</label>
                    <Select
                      name="PersonalAreaID"
                      onChange={(e, action) => handleSelect(e, action.name)}
                      value={personalAreaOption.find((o) => o.value == formData.PersonalAreaID)}
                      className={`form-control-select ${errors?.PersonalAreaID ? "is-invalid" : ""}`} isDisabled={String(formData.RequirementHiringType) === "4"} 
                      options={personalAreaOption}
                    />
                  </div>
                </div>
                <div className="row mt-4">
                  <div className="col-sm-12">
                    <label className="form-label">Employee Group{String(formData.RequirementHiringType) !== "4" && <span className="text-danger">*</span>}</label>
                    <Select
                      name="EmployeeGroup_ID"
                      onChange={(e, action) => handleSelect(e, action.name)}
                      value={employeeGroupOption.find((o) => o.value == formData.EmployeeGroup_ID)}
                      className={`form-control-select ${errors?.EmployeeGroup_ID ? "is-invalid" : ""}`} isDisabled={String(formData.RequirementHiringType) === "4"} 
                      options={employeeGroupOption}
                    />
                  </div>
                </div>

              </div>
              
              <div className="col-sm-12 pb-2 mt-1">
                <div className="d-flex justify-content-end align-items-end m-2  text-right me-2">
                  <button
                    type="button"
                    className="cancel-btn me-2"
                    onClick={() => navigate("/customer-requirement")}
                  >
                    Cancel
                  </button>

                  <button
                    disabled={loading ? true : false}
                    type="submit"
                    className="custom-btn "
                  >
                    {loading ? <FaSpinner class="sm-spinner" /> : "Submit"}
                  </button>
                </div>
              </div>

              {/* grid one end */}

              <div className="col-md-12 flex-col mt-1">
                <div className="table-responsive poc-head rounded">
                  <Table
                    style={{ background: "#ECECEC !important" }}
                    className="table table-bordered"
                  >
                    <thead id="thcolor" className="text-center">
                      <tr>
                        <th className="text-center">Sr.No.</th>
                        <th className="border-1 px-0 align-middle fs-10">
                          Name
                        </th>
                        <th className="border-1 px-0 align-middle fs-9">
                          Type
                        </th>
                        <th className="border-1 px-0 align-middle fs-9">
                          Skill
                        </th>
                        <th
                          className="border-1 px-0 align-middle fs-9"
                          style={{ width: "150px" }}
                        >
                          SubSkill
                        </th>
                        <th className="border-1 px-0 align-middle fs-9">
                          Curr. Proj.
                        </th>
                        <th className="border-1 px-0 align-middle fs-9">
                          Proj. End Date
                        </th>
                        <th className="align-middle fs-9">Rel. Exp.</th>
                        <th className="align-middle fs-9">Curr. Designation</th>
                        <th className="align-middle fs-9">Appl. Status</th>
                        <th className="align-middle fs-9">Reason</th>
                        <th className="align-middle fs-9">Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {mergeLineData.map((ele, index) => (
                        <tr key={index}>
                          <td
                            className="align-middle text-center"
                            style={{
                              maxWidth: "80px",
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                            }}
                          >
                            {index + 1}
                          </td>

                          {ele?.EmpName || ele?.ClientName ? (
                            <OverlayTrigger
                              placement="right"
                              overlay={
                                <div
                                  style={{
                                    position: "absolute",
                                    backgroundColor: "#2F2E4B",
                                    padding: "2px 10px",
                                    color: "white",
                                    borderRadius: 3,
                                    width: "150px",
                                  }}
                                >
                                  {ele?.EmpName || ele?.ClientName}
                                </div>
                              }
                            >
                              <td
                                style={{
                                  maxWidth: "100px",
                                  whiteSpace: "nowrap",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                }}
                              >
                                {ele?.EmpName || ele?.ClientName}
                              </td>
                            </OverlayTrigger>
                          ) : (
                            <td
                              style={{
                                maxWidth: "100px",
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                              }}
                            >
                              {ele?.EmpName || ele?.ClientName}
                            </td>
                          )}

                          {ele?.Type ? (
                            <OverlayTrigger
                              placement="right"
                              overlay={
                                <div
                                  style={{
                                    position: "absolute",
                                    backgroundColor: "#2F2E4B",
                                    padding: "2px 10px",
                                    color: "white",
                                    borderRadius: 3,
                                    width: "150px",
                                  }}
                                >
                                  {ele?.Type}
                                </div>
                              }
                            >
                              <td
                                style={{
                                  maxWidth: "100px",
                                  whiteSpace: "nowrap",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                }}
                              >
                                {ele?.Type}
                              </td>
                            </OverlayTrigger>
                          ) : (
                            <td
                              style={{
                                maxWidth: "100px",
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                              }}
                            >
                              {ele?.Type}
                            </td>
                          )}

                          {ele?.SkillName || ele?.TechnologyID ? (
                            <OverlayTrigger
                              placement="right"
                              overlay={
                                <div
                                  style={{
                                    position: "absolute",
                                    backgroundColor: "#2F2E4B",
                                    padding: "2px 10px",
                                    color: "white",
                                    borderRadius: 3,
                                    width: "150px",
                                  }}
                                >
                                  {ele?.SkillName || ele?.TechnologyID}
                                </div>
                              }
                            >
                              <td
                                style={{
                                  maxWidth: "100px",
                                  whiteSpace: "nowrap",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                }}
                              >
                                {ele?.SkillName || ele?.TechnologyID}
                              </td>
                            </OverlayTrigger>
                          ) : (
                            <td
                              style={{
                                maxWidth: "100px",
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                              }}
                            >
                              {ele?.SkillName || ele?.TechnologyID}
                            </td>
                          )}

                          {ele?.SubSkillName ? (
                            <OverlayTrigger
                              placement="right"
                              overlay={
                                <div
                                  style={{
                                    position: "absolute",
                                    backgroundColor: "#2F2E4B",
                                    padding: "2px 10px",
                                    color: "white",
                                    borderRadius: 3,
                                    width: "150px",
                                  }}
                                >
                                  {ele?.SubSkillName}
                                </div>
                              }
                            >
                              <td
                                style={{
                                  maxWidth: "100px",
                                  whiteSpace: "nowrap",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                }}
                              >
                                {ele?.SubSkillName}
                              </td>
                            </OverlayTrigger>
                          ) : (
                            <td
                              style={{
                                maxWidth: "100px",
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                              }}
                            >
                              {ele?.SubSkill}
                            </td>
                          )}

                          {ele?.Project ? (
                            <OverlayTrigger
                              placement="right"
                              overlay={
                                <div
                                  style={{
                                    position: "absolute",
                                    backgroundColor: "#2F2E4B",
                                    padding: "2px 10px",
                                    color: "white",
                                    borderRadius: 3,
                                    width: "150px",
                                  }}
                                >
                                  {ele?.Project}
                                </div>
                              }
                            >
                              <td
                                style={{
                                  maxWidth: "100px",
                                  whiteSpace: "nowrap",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                }}
                              >
                                {ele?.Project}
                              </td>
                            </OverlayTrigger>
                          ) : (
                            <td
                              style={{
                                maxWidth: "100px",
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                              }}
                            >
                              {ele?.Project}
                            </td>
                          )}

                          {ele?.EndDate ? (
                            <OverlayTrigger
                              placement="right"
                              overlay={
                                <div
                                  style={{
                                    position: "absolute",
                                    backgroundColor: "#2F2E4B",
                                    padding: "2px 10px",
                                    color: "white",
                                    borderRadius: 3,
                                    width: "150px",
                                  }}
                                >
                                  {moment(ele?.EndDate).format("DD-MMM-YYYY")}
                                </div>
                              }
                            >
                              <td
                                style={{
                                  maxWidth: "100px",
                                  whiteSpace: "nowrap",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                }}
                              >
                                {moment(ele?.EndDate).format("DD-MMM-YYYY")}
                              </td>
                            </OverlayTrigger>
                          ) : (
                            <td
                              style={{
                                maxWidth: "100px",
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                              }}
                            >
                              {null}
                            </td>
                          )}

                          {ele?.RelevantExp || ele?.EXP ? (
                            <OverlayTrigger
                              placement="right"
                              overlay={
                                <div
                                  style={{
                                    position: "absolute",
                                    backgroundColor: "#2F2E4B",
                                    padding: "2px 10px",
                                    color: "white",
                                    borderRadius: 3,
                                    width: "150px",
                                  }}
                                >
                                  {ele?.RelevantExp || ele?.EXP}
                                </div>
                              }
                            >
                              <td
                                style={{
                                  maxWidth: "100px",
                                  whiteSpace: "nowrap",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                }}
                              >
                                {ele?.RelevantExp || ele?.EXP}
                              </td>
                            </OverlayTrigger>
                          ) : (
                            <td
                              style={{
                                maxWidth: "100px",
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                              }}
                            >
                              {ele?.RelevantExp || ele?.EXP}
                            </td>
                          )}

                          {(() => {
                            const displayDesignation = (ele?.Type === 'Pipeline' || ele?.IsEmployee === 3)
                              ? (ele?.Designation && ele?.Designation !== ele?.Role ? ele?.Designation : '')
                              : (ele?.Designation || ele?.Role);

                            return displayDesignation ? (
                              <OverlayTrigger
                                placement="right"
                                overlay={
                                  <div
                                    style={{
                                      position: "absolute",
                                      backgroundColor: "#2F2E4B",
                                      padding: "2px 10px",
                                      color: "white",
                                      borderRadius: 3,
                                      width: "150px",
                                    }}
                                  >
                                    {displayDesignation}
                                  </div>
                                }
                              >
                                <td
                                  style={{
                                    maxWidth: "100px",
                                    whiteSpace: "nowrap",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                  }}
                                >
                                  {displayDesignation}
                                </td>
                              </OverlayTrigger>
                            ) : (
                              <td
                                style={{
                                  maxWidth: "100px",
                                  whiteSpace: "nowrap",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                }}
                              >
                                {displayDesignation}
                              </td>
                            );
                          })()}

                          {ele?.SelectionStatus ? (
                            <OverlayTrigger
                              placement="right"
                              overlay={
                                <div
                                  style={{
                                    position: "absolute",
                                    backgroundColor: "#2F2E4B",
                                    padding: "2px 10px",
                                    color: "white",
                                    borderRadius: 3,
                                    width: "150px",
                                  }}
                                >
                                  {ele?.SelectionStatus == 1
                                    ? "Accepted"
                                    : ele?.SelectionStatus == 2
                                    ? "Declined"
                                    : ele?.SelectionStatus == 3
                                    ? "Pending"
                                    : ele?.SelectionStatus == 0
                                    ? "New"
                                    : ele?.SelectionStatus == 5
                                    ? "Activate"
                                    : ""}
                                </div>
                              }
                            >
                              <td
                                style={{
                                  maxWidth: "100px",
                                  whiteSpace: "nowrap",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                }}
                              >
                                {ele?.SelectionStatus == 1
                                  ? "Accepted"
                                  : ele?.SelectionStatus == 2
                                  ? "Declined"
                                  : ele?.SelectionStatus == 3
                                  ? "Pending"
                                  : ele?.SelectionStatus == 0
                                  ? "New"
                                  : ele?.SelectionStatus == 5
                                  ? "Activate"
                                  : ""}
                              </td>
                            </OverlayTrigger>
                          ) : (
                            <td
                              style={{
                                maxWidth: "100px",
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                              }}
                            >
                              {ele?.SelectionStatus == 1
                                ? "Accepted"
                                : ele?.SelectionStatus == 2
                                ? "Declined"
                                : ele?.SelectionStatus == 3
                                ? "Pending"
                                : ele?.SelectionStatus == 0
                                ? "New"
                                : ele?.SelectionStatus == 5
                                ? "Activate"
                                : ""}
                            </td>
                          )}

                          {ele?.Remarks ? (
                            <OverlayTrigger
                              placement="right"
                              overlay={
                                <div
                                  style={{
                                    position: "absolute",
                                    backgroundColor: "#2F2E4B",
                                    padding: "2px 10px",
                                    color: "white",
                                    borderRadius: 3,
                                    width: "150px",
                                  }}
                                >
                                  {ele?.Remarks}
                                </div>
                              }
                            >
                              <td
                                style={{
                                  maxWidth: "100px",
                                  whiteSpace: "nowrap",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                }}
                              >
                                {ele?.Remarks}
                              </td>
                            </OverlayTrigger>
                          ) : (
                            <td
                              style={{
                                maxWidth: "100px",
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                              }}
                            >
                              {ele?.Remarks}
                            </td>
                          )}

                          <td>
                            <div className="d-flex justify-content-between ">
                              <>
                                {/* Accept Icon */}
                                <OverlayTrigger
                                  placement="bottom"
                                  overlay={
                                    <Tooltip id="tooltip-bottom">
                                      {"Accept"}
                                    </Tooltip>
                                  }
                                >
                                  <i
                                    style={{ fontWeight: "bold" }}
                                    className={`bi bi-check icons me-1 ${
                                      ele?.SelectionStatus !== 0 &&
                                      ele?.SelectionStatus !== 3 &&
                                      ele?.SelectionStatus !== 5
                                        ? "disabled-icon"
                                        : ""
                                    }`}
                                    name="Accept"
                                    onClick={(e) => {
                                      if (
                                        ele?.SelectionStatus === 0 ||
                                        ele?.SelectionStatus === 3 ||
                                        ele?.SelectionStatus == 5
                                      ) {
                                        handleAccept(e, "Accept", 1, ele);
                                      }
                                    }}
                                  ></i>
                                </OverlayTrigger>

                                {/* Decline Icon */}
                                <OverlayTrigger
                                  placement="bottom"
                                  overlay={
                                    <Tooltip id="tooltip-bottom">
                                      {"Decline"}
                                    </Tooltip>
                                  }
                                >
                                  <i
                                    style={{ fontWeight: "bold" }}
                                    className={`bi bi-x icons me-1 ${
                                      ele?.SelectionStatus !== 0 &&
                                      ele?.SelectionStatus !== 3 &&
                                      ele?.SelectionStatus !== 5
                                        ? "disabled-icon"
                                        : ""
                                    }`}
                                    onClick={(e) => {
                                      if (
                                        ele?.SelectionStatus === 0 ||
                                        ele?.SelectionStatus === 3 ||
                                        ele?.SelectionStatus == 5
                                      ) {
                                        handleAccept(e, "Decline", 2, ele);
                                      }
                                    }}
                                  ></i>
                                </OverlayTrigger>

                                {/* Pending Icon */}
                                <OverlayTrigger
                                  placement="bottom"
                                  overlay={
                                    <Tooltip id="tooltip-bottom">
                                      {"Pending"}
                                    </Tooltip>
                                  }
                                >
                                  <i
                                    style={{ fontWeight: "bold" }}
                                    className={`bi bi-hourglass-split icons me-1 ${
                                      ele?.SelectionStatus !== 0 &&
                                      ele?.SelectionStatus !== 5
                                        ? "disabled-icon"
                                        : ""
                                    }`}
                                    onClick={(e) => {
                                      if (
                                        ele?.SelectionStatus === 0 ||
                                        ele?.SelectionStatus == 5
                                      ) {
                                        handleAccept(e, "Pending", 3, ele);
                                      }
                                    }}
                                  ></i>
                                </OverlayTrigger>

                                {/* Edit Details Icon */}
                                <OverlayTrigger
                                  placement="bottom"
                                  overlay={
                                    <Tooltip id="tooltip-bottom">
                                      {"Edit Details"}
                                    </Tooltip>
                                  }
                                >
                                  <i
                                    style={{ fontWeight: "bold" }}
                                    className={`bi bi-pencil-square icons me-1 ${
                                      ele?.SelectionStatus !== 1
                                        ? "disabled-icon"
                                        : ""
                                    }`}
                                    onClick={(e) => {
                                      if (ele?.SelectionStatus === 1) {
                                        handleEditDetails(e, ele);
                                      }
                                    }}
                                  ></i>
                                </OverlayTrigger>

                                {/* Amendment Log Icon */}
                                <OverlayTrigger
                                  placement="bottom"
                                  overlay={
                                    <Tooltip id="tooltip-bottom">
                                      {"Amendment Log"}
                                    </Tooltip>
                                  }
                                >
                                  <i
                                    style={{ fontWeight: "bold" }}
                                    className={`bi bi-clock-history icons me-1 ${
                                      ele?.SelectionStatus !== 1
                                        ? "disabled-icon"
                                        : ""
                                    }`}
                                    onClick={(e) => {
                                      if (ele?.SelectionStatus === 1) {
                                        handleAmendment(ele, "Amendment Log");
                                      }
                                    }}
                                  ></i>
                                </OverlayTrigger>

                                {/* Activate Icon */}
                                <OverlayTrigger
                                  placement="bottom"
                                  overlay={
                                    <Tooltip id="tooltip-bottom">
                                      {"Activate"}
                                    </Tooltip>
                                  }
                                >
                                  <i
                                    style={{ fontWeight: "bold" }}
                                    className={`bi bi-toggle-off icons me-2 ${
                                      ele?.SelectionStatus !== 2
                                        ? "disabled-icon"
                                        : ""
                                    }`}
                                    onClick={(e) => {
                                      if (ele?.SelectionStatus === 2) {
                                        handleAccept(e, "Activate", 5, ele);
                                      }
                                    }}
                                  ></i>
                                </OverlayTrigger>
                              </>
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </div>
              </div>
            </div>
          </div>
        </form>
        {/* </div> */}

        {/* <Modal
          show={showAcceptModal}
          onHide={handleAcceptModalClose}
          dialogClassName="modal-md"
        >
          <div
            style={{ backgroundColor: "#F2F2F4" }}
            className="card rounded border-0 m-2"
          >
            <Modal.Header scloseButton className="p-0 px-3">
              <Modal.Title className="text-info">
                <div className="text-center d-flex justify-center">
                  <h2 style={{ fontWeight: "800", color: "#2F2E4B" }}>
                    {modalName}Reason
                  </h2>
                </div>
              </Modal.Title>
            </Modal.Header>
            <Modal.Body
              className="rounded m-3 py-0 px-3"
            // style={{
            //   maxHeight: "60vh",
            //   overflow: "scroll",
            //   backgroundColor: "white",
            // }}
            >
              <textarea
                className="form-control"
                name="AdditionalComments"
                onChange={handleReasonChange}
                value={reason}
              ></textarea>
            </Modal.Body>
            <Modal.Footer className="p-0 px-3">
              <Button
                className="custom-btn text-white "
                onClick={handleAcceptModalClose}
              >
                No
              </Button>
              <Button
                className="custom-btn text-white "
                type="button"
                disabled={loading ? true : false}
                onClick={(e) => handleModalSubmit(e)}
              >
                {loading ? <FaSpinner class="sm-spinner" /> : "Yes"}
              </Button>
            </Modal.Footer>
          </div>
        </Modal> */}
        <Modal
          show={showAcceptModal}
          onHide={handleAcceptModalClose}
          dialogClassName="modal-sm"
          centered
        >
          <div className="modal-content" style={{ borderRadius: "8px" }}>
            <div
              className="modal-header"
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                borderBottom: "1px solid #f0f0f0",
                backgroundColor: "#f8f9fa",
                borderRadius: "8px 8px 0 0",
                padding: "12px 16px",
              }}
            >
              <p
                style={{
                  fontSize: "16px",
                  fontWeight: "600",
                  color: "#27568B",
                  margin: "0",
                }}
              >
                {modalName} Reason
              </p>
              <button
                onClick={handleAcceptModalClose}
                style={{
                  background: "none",
                  border: "none",
                  cursor: "pointer",
                  fontSize: "18px",
                  color: "#000",
                  padding: "4px",
                  borderRadius: "4px",
                  transition: "all 0.2s",
                  lineHeight: "1",
                }}
              >
                <i className="bi bi-x-lg"></i>
              </button>
            </div>
            <div className="modal-body p-1">
              <textarea
                className="form-control"
                name="AdditionalComments"
                onChange={handleReasonChange}
                value={reason}
                placeholder="Remark"
                style={{ minHeight: "40px" }}
              ></textarea>
            </div>
            <div
              className="mt-2 mb-1"
              style={{
                padding: "2px 4px",
                display: "flex",
                justifyContent: "end",
              }}
            >
              <button
                type="button"
                className="cancel-btn-sm me-1"
                onClick={handleAcceptModalClose}
              >
                No
              </button>
              <button
                type="button"
                className="custom-btn-sm"
                disabled={loading ? true : false}
                onClick={(e) => handleModalSubmit(e)}
              >
                {loading ? <FaSpinner className="sm-spinner" /> : "Yes"}
              </button>
            </div>
          </div>
        </Modal>

        {/*     Billing Dialog Box Code Start        */}
        {/* <Modal
          show={editDetailsModal}
          onHide={handleEditDetailsClose}
          dialogClassName="modal-lg"
        >
          <div
            style={{ backgroundColor: "#F2F2F4" }}
            className="card rounded border-0 m-2"
          >
            <Modal.Header scloseButton className="p-0 px-2">
              <Modal.Title className="text-info">
                <div className="text-center d-flex justify-center">
                  <h2 style={{ fontWeight: "800", color: "#2F2E4B" }}>
                    {selectedlistEmp?.EmpName || selectedlistEmp?.ClientName}
                  </h2>
                </div>
              </Modal.Title>
            </Modal.Header>

            <Modal.Body
              className="rounded m-3 py-0 px-3"
            >
              <div className="conatiner-fluid">
                <div className="row">
                  <div className="col-md-4">
                    <label className="form-label">Billing Rate</label>
                    <input
                      type="text"
                      className={`form-control`}
                      name="Cost"
                      onChange={handleBillingChange}
                      value={billingFormData.Cost}
                    />
                  </div>
                  <div className="col-md-4">
                    {" "}
                    <label className="form-label">Currency</label>
                    <Select
                      name="currency"
                      onChange={handleBillingSelect}
                      options={billingCurrencyOptions}
                      value={billingCurrencyOptions.find(
                        (ele) => ele.value === billingFormData.currency
                      )}
                    />
                  </div>{" "}
                  <div className="col-md-4">
                    {" "}
                    <label className="form-label">Frequency</label>
                    <Select
                      name="Frequency"
                      onChange={handleBillingSelect}
                      options={frequencyOptions}
                      value={frequencyOptions.find(
                        (ele) => ele.value == Number(billingFormData.Frequency)
                      )}
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-4">
                    {" "}
                    <label className="form-label">Submission Date</label>
                    <CustomDatePicker
                      handleChange={(e) => handleBillingChange(e)}
                      value={billingFormData.SubmissionDate}
                      name="SubmissionDate"
                      className="form-control"
                      placeholderText="DD-MM-YYYY"
                      readOnly={billingFormData.SubmissionDate && billingFormData.SubmissionDate !== '' && billingFormData.SubmissionDate !== null}
                    // readOnly={true}
                    />
                  </div>
                  <div className="col-md-4">
                    {" "}
                    <label className="form-label">Interview Date</label>
                    <CustomDatePicker
                      handleChange={(e) => handleBillingChange(e)}
                      value={billingFormData.InterviewDate}
                      name="InterviewDate"
                      className="form-control"
                      placeholderText="DD-MM-YYYY"
                      minDate={new Date(billingFormData.SubmissionDate)}
                    />
                  </div>{" "}
                  <div className="col-md-4">
                    <label className="form-label">Round</label>
                    <Select
                      name="Round"
                      onChange={handleBillingSelect}
                      options={romRoundOptions}
                      value={romRoundOptions.find(
                        (ele) => ele.value === billingFormData.Round
                      )}

                    />
                  </div>{" "}
                </div>
                <div className="row">
                  <div className="col-md-4">
                    <label className="form-label">Status</label>
                    <Select
                      name="status"
                      onChange={handleBillingSelect}
                      options={processStatusOptions}
                      value={processStatusOptions.find(
                        (ele) => ele.value == billingFormData.status
                      )}
                    />
                  </div>{" "}
                  <div className="col-md-4">
                    <label className="form-label">Project DOJ</label>
                    <CustomDatePicker
                      handleChange={(e) => handleBillingChange(e)}
                      value={billingFormData.ProjectDOJ}
                      name="ProjectDOJ"
                      className="form-control"
                      placeholderText="DD-MM-YYYY"
                    />
                  </div>{" "}
                  <div className="col-md-4 ">
                    <label class="form-label">Remark</label>
                    <textarea
                      placeholder="Remark"
                      className="form-control"
                      name="AdditionalComments"
                      onChange={handleBillingChange}
                      value={billingFormData.AdditionalComments}
                    ></textarea>
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-3 ">
                    <div className=" mt-3 ">
                      <FileUploader handleFile={handleFile} isRequired={false} />
                      {formData.Resume || fileName ? (
                        <p>
                          Resume:{" "}
                          <a
                            target="_blank"
                            href={
                              "http://localhost:8000/storage/uploads/resume/" +
                              formData.Resume
                            }
                          >
                            {fileName ? fileName : formData.Resume}
                          </a>
                        </p>
                      ) : null}
                    </div>
                  </div>
                </div>
              </div>
            </Modal.Body>
            <Modal.Footer className="p-0 px-3">
              <button
                className="cancel-btn"
                onClick={handleEditDetailsClose}
              >
                Cancel
              </button>
              <button
                type="button"
                className="custom-btn text-white"
                disabled={loading ? true : false}
                onClick={(e) => handleBillingSubmit(e)}
              >
                {loading ? <FaSpinner class="sm-spinner" /> : "Add"}
              </button>
            </Modal.Footer>
          </div>
        </Modal> */}
        <Modal
          show={editDetailsModal}
          onHide={handleEditDetailsClose}
          dialogClassName="modal-lg"
          centered
        >
          <div className="modal-content" style={{ borderRadius: "8px" }}>
            <div
              className="modal-header"
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                borderBottom: "1px solid #f0f0f0",
                backgroundColor: "#f8f9fa",
                borderRadius: "8px 8px 0 0",
                padding: "16px",
              }}
            >
              <h2
                style={{
                  fontWeight: "800",
                  color: "#2F2E4B",
                  fontSize: "20px",
                  margin: 0,
                }}
              >
                {selectedlistEmp?.EmpName || selectedlistEmp?.ClientName}
              </h2>
              <button
                onClick={handleEditDetailsClose}
                style={{
                  background: "none",
                  border: "none",
                  cursor: "pointer",
                  fontSize: "18px",
                  color: "#000",
                  padding: "4px",
                  borderRadius: "4px",
                  transition: "all 0.2s",
                  lineHeight: "1",
                }}
              >
                <i className="bi bi-x-lg"></i>
              </button>
            </div>

            <div className="modal-body p-1 bg-white">
              <div className="container-fluid">
                <div className="row mb-3">
                  <div className="col-md-4">
                    <label className="form-label">Billing Rate</label>
                    <input
                      type="text"
                      className={`form-control`}
                      name="Cost"
                      onChange={handleBillingChange}
                      value={billingFormData.Cost}
                    />
                  </div>
                  <div className="col-md-4">
                    <label className="form-label">Currency</label>
                    <Select
                      name="currency"
                      onChange={handleBillingSelect}
                      options={billingCurrencyOptions}
                      value={billingCurrencyOptions.find(
                        (ele) => ele.value === billingFormData.currency
                      )}
                    />
                  </div>
                  <div className="col-md-4">
                    <label className="form-label">Frequency</label>
                    <Select
                      name="Frequency"
                      onChange={handleBillingSelect}
                      options={frequencyOptions}
                      value={frequencyOptions.find(
                        (ele) => ele.value == Number(billingFormData.Frequency)
                      )}
                    />
                  </div>
                </div>

                <div className="row mb-3">
                  <div className="col-md-4">
                    <label className="form-label">Submission Date</label>
                    <CustomDatePicker
                      handleChange={(e) => handleBillingChange(e)}
                      value={billingFormData.SubmissionDate}
                      name="SubmissionDate"
                      className="form-control"
                      placeholderText="DD-MM-YYYY"
                      readOnly={
                        billingFormData.SubmissionDate &&
                        billingFormData.SubmissionDate !== "" &&
                        billingFormData.SubmissionDate !== null &&
                        billingFormData.RevisionNumber != 1
                      }
                    />
                  </div>
                  <div className="col-md-4">
                    <label className="form-label">Interview Date</label>
                    <CustomDatePicker
                      handleChange={(e) => handleBillingChange(e)}
                      value={billingFormData.InterviewDate}
                      name="InterviewDate"
                      className="form-control"
                      placeholderText="DD-MM-YYYY"
                      minDate={new Date(billingFormData.SubmissionDate)}
                    />
                  </div>
                  <div className="col-md-4">
                    <label className="form-label">Round</label>
                    <Select
                      name="Round"
                      onChange={handleBillingSelect}
                      options={romRoundOptions}
                      value={romRoundOptions.find(
                        (ele) => ele.value === billingFormData.Round
                      )}
                    />
                  </div>
                </div>

                <div className="row mb-3">
                  <div className="col-md-4">
                    <label className="form-label">Status</label>
                    <Select
                      name="status"
                      onChange={(selectedOption, action) => {
                        handleBillingSelect(selectedOption, action);
                        setIsbBillingStatusChange(1);
                      }}
                      options={processStatusOptions}
                      value={processStatusOptions.find(
                        (ele) => ele.value == billingFormData.status
                      )}
                    />
                  </div>
                  <div className="col-md-4">
                    <label className="form-label">Project DOJ</label>
                    <CustomDatePicker
                      handleChange={(e) => handleBillingChange(e)}
                      value={billingFormData.ProjectDOJ}
                      name="ProjectDOJ"
                      className="form-control"
                      placeholderText="DD-MM-YYYY"
                    />
                  </div>
                  <div className="col-md-4">
                    <label className="form-label">Remark</label>
                    <textarea
                      placeholder="Remark"
                      className="form-control"
                      name="AdditionalComments"
                      onChange={handleBillingChange}
                      value={billingFormData.AdditionalComments}
                      style={{ minHeight: "80px" }}
                    ></textarea>
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-4">
                    <div className="mt-2">
                      <FileUploader
                        handleFile={handleFile}
                        isRequired={false}
                      />
                      {formData.Resume || fileName ? (
                        <p className="mt-2">
                          Resume:{" "}
                          <a target="_blank" 
                          href={resumeLink}  
                          style={{ color: "blue", textDecoration: "underline", cursor:"pointer" }}>
                            {fileName ? fileName : formData.Resume}
                          </a>
                        </p>
                      ) : null}
                    </div>
                  </div>
                </div>
                {errors?.resumeFile && (
  <p style={{ color: "red", marginTop: "5px" }}>{errors.resumeFile}</p>
)}

                <div className="row m-0 p-0">
                     <span className="attach_msg">
                           Please upload all the files in DOC, DOCX, or PDF format.
                        </span>
                </div>
              </div>
            </div>

            <div
              style={{
                padding: "5px",
                display: "flex",
                justifyContent: "end",
              }}
            >
              <button
                className="cancel-btn me-2"
                onClick={handleEditDetailsClose}
              >
                Cancel
              </button>
              <button
                type="button"
                className="custom-btn"
                disabled={loading ? true : false}
                onClick={(e) => handleBillingSubmit(e)}
              >
                {loading ? <FaSpinner className="sm-spinner" /> : "Add"}
              </button>
            </div>
          </div>
        </Modal>
      </div>
    </>
  );
};

export default EditCustomerRequirement;

